<template>
    <div>
        <el-form style="width: 1500px;" :inline="true" :model="rollingForm" :rules="rollingRules" ref="rollingForm" class="demo-form-inline" size="small">
            <el-row :gutter="0">
                <el-col :span="4">
                    <el-form-item label-width="100px" label="日期：" prop="feedDate">
                        <el-date-picker
                                v-model="rollingForm.feedDate"
                                type="date"
                                placeholder=""
                                style="width:140px"
                                :disabled="disabledNum"
                        >
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="車號：" prop="carNumber">
                        <el-input placeholder=""  clearable v-model="rollingForm.carNumber" style="width: 100px;" @change="validateCarNumber(rollingForm.carNumber)" :disabled="disabledNum">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="扎車(坑紙)" prop="oneCar">
                        <el-input placeholder="坑紙"  clearable v-model="rollingForm.oneCar" @change="validatePitPaperTitle(rollingForm.oneCar)" :disabled="disabledNum" style="width: 100px;">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="扎車(地膠)" prop="twoCar">
                        <el-input placeholder="地膠"  clearable v-model="rollingForm.twoCar" @change="validateTwoCarTitle(rollingForm.twoCar)" :disabled="disabledNum" style="width: 100px;">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="110px"label="扎車(縐紋紙)" prop="threeCar">
                        <el-input placeholder="縐紋紙"  clearable v-model="rollingForm.threeCar" @change="validateThreeTitle(rollingForm.threeCar)" :disabled="disabledNum" style="width: 100px;">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <div v-for="poiItem in poiItemList">
                <el-row :gutter="0" v-if="poiItem.index!=1">
                    <div style="margin-left: 100px;border:1px dashed #000;width: 73%;margin-bottom: 3px;"></div>
                </el-row>
                <el-row :gutter="0">
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="坑紙"   prop="pitPaper">
                            <el-input placeholder="" v-model="poiItem.pitPaper" clearable style="width: 100px;" @change="validatePitPaper(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">卷</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="報紙" prop="newsPaper">
                            <el-input placeholder="" v-model="poiItem.newsPaper" clearable style="width: 100px;" @change="validatenewsPaper(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">卷</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="卜卜膠" prop="buBu">
                            <el-input placeholder="" v-model="poiItem.buBu" clearable style="width: 100px;" @change="validatebuBu(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">卷</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="拷貝紙" prop="copyPaper">
                            <el-input placeholder="" v-model="poiItem.copyPaper" clearable style="width: 100px;" @change="validatecopyPaper(poiItem)" :disabled="disabledNum" >
                            </el-input>
                            <span style="color: #000000">卷</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="110px" label="毡" prop="mat">
                            <el-input placeholder="" v-model="poiItem.mat" clearable style="width: 100px;" @change="validatemat(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">盒</span>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="0">
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="保鮮紙" prop="tinFoil">
                            <el-input placeholder="" v-model="poiItem.tinFoil" clearable style="width: 100px;" @change="validatetinFoil(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">卷</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="高木箱" prop="azusa">
                            <el-input placeholder="" v-model="poiItem.azusa" clearable style="width: 100px;" @change="validateazusa(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">個</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="矮木箱" prop="shortWood">
                            <el-input placeholder="" v-model="poiItem.shortWood" clearable style="width: 100px;" @change="validateshortWood(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">個</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="鐵車" prop="ironCar">
                            <el-input placeholder="" v-model="poiItem.ironCar" clearable style="width: 100px;" @change="validateironCar(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">部</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="110px" label="車仔" prop="chelsea">
                            <el-input placeholder="" v-model="poiItem.chelsea" clearable style="width: 100px;" @change="validatechelsea(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">部</span>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="0">
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="軟紙"  prop="softPaper">
                            <el-input placeholder="" v-model="poiItem.softPaper" clearable style="width: 100px;" @change="validatesoftPaper(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">扎</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="爛紙" prop="lousyPaper">
                            <el-input placeholder="" v-model="poiItem.lousyPaper" clearable style="width: 100px;" @change="validatelousyPaper(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">盒</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="防潮珠" prop="moistureproof">
                            <el-input placeholder="" v-model="poiItem.moistureproof" clearable style="width: 100px;" @change="validatemoistureproof(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">袋</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="電批" prop="electric">
                            <el-input placeholder="" v-model="poiItem.electric" clearable style="width: 100px;" @change="validateelectric(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">個</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="110px" label="叉" prop="fork">
                            <el-input placeholder="" v-model="poiItem.fork" clearable style="width: 100px;" @change="validatefork(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">個</span>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="0">
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="散箱" prop="bulktank">
                            <el-input placeholder="" v-model="poiItem.bulktank" clearable style="width: 100px;" @change="validatebulktank(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">個</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="地膠" prop="toGlue">
                            <el-input placeholder="" v-model="poiItem.toGlue" clearable style="width: 100px;" @change="validatetoGlue(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">卷</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="膠紙" prop="gummedPaper">
                            <el-input placeholder="" v-model="poiItem.gummedPaper" clearable style="width: 100px;" @change="validategummedPaper" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">卷</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="铁笼" prop="cage">
                            <el-input placeholder="" v-model="poiItem.cage" clearable style="width: 100px;" @change="validatecage(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">件</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="110px" label="夾板(長)" prop="plywood">
                            <el-input placeholder="" v-model="poiItem.plywood" clearable style="width: 100px;" @change="validateplywood(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">件</span>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="0">
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="紙卡板" prop="paperCardBoard">
                            <el-input placeholder="" v-model="poiItem.paperCardBoard" clearable style="width: 100px;" @change="validatepaperCardBoard(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">件</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="開木箱工具" prop="tool">
                            <el-input placeholder="" v-model="poiItem.tool" clearable style="width: 100px;" @change="validatetool(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">套</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="膠(110cm)" prop="glue">
                            <el-input placeholder="" v-model="poiItem.glue" clearable style="width: 100px;" @change="validateglue(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">件</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="Plasma" prop="plasma">
                            <el-input placeholder="" v-model="poiItem.plasma" clearable style="width: 100px;" @change="validateplasma(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">個</span>
                        </el-form-item>
                    </el-col> <el-col :span="4">
                    <el-form-item label-width="110px" label="縐紋紙" prop="crepePaper">
                        <el-input placeholder="" v-model="poiItem.crepePaper" clearable style="width: 100px;" @change="validatecrepePaper(poiItem)" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">卷</span>
                    </el-form-item>
                </el-col>
                </el-row>
                <el-row :gutter="0">
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="平衣" prop="flatClothing">
                            <el-input placeholder="" v-model="poiItem.flatClothing" clearable style="width: 100px;" @change="validateflatClothing(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">個</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="冰箱" prop="refrigerator">
                            <el-input placeholder="" v-model="poiItem.refrigerator" clearable style="width: 100px;" @change="validaterefrigerator(poiItem)"  :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">個</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="黑色橡筋" prop="elastic">
                            <el-input placeholder="" v-model="poiItem.elastic" clearable style="width: 100px;" @change="validateelastic(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">扎</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="紙板" prop="cardboard">
                            <el-input placeholder="" v-model="poiItem.cardboard" clearable style="width: 100px;" @change="validatecardboard(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">塊</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="110px" label="企身" prop="stiff">
                            <el-input placeholder="" v-model="poiItem.stiff" clearable style="width: 100px;" @change="validatestiff(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">套</span>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="0">
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="地台板(長)" prop="lengthFloor">
                            <el-input placeholder="" v-model="poiItem.lengthFloor" clearable style="width: 100px;" @change="validatelengthFloor(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">件</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="地台板(短)" prop="shortFloor">
                            <el-input placeholder="" v-model="poiItem.shortFloor" clearable style="width: 100px;" @change="validateshortFloor(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">件</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="吊繩" prop="theWire">
                            <el-input placeholder="" v-model="poiItem.theWire" clearable style="width: 100px;" @change="validatetheWire(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">套</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="滑潤" prop="smooth">
                            <el-input placeholder="" v-model="poiItem.smooth" clearable style="width: 100px;" @change="validatesmooth(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">套</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="110px" label="膠(120cm)" prop="oneGlue">
                            <el-input placeholder="" v-model="poiItem.oneGlue" clearable style="width: 100px;" @change="validateoneGlue(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">件</span>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="0">
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="積車" prop="productCar">
                            <el-input placeholder="" v-model="poiItem.productCar" clearable style="width: 100px;" @change="validateproductCar(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">部</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="搬花網" prop="wireMesh">
                            <el-input placeholder="" v-model="poiItem.wireMesh" clearable style="width: 100px;" @change="validatewireMesh(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">個</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="膠紙冚" prop="tape">
                            <el-input placeholder="" v-model="poiItem.tape" clearable style="width: 100px;" @change="validatetape(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">個</span>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="0">
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="紙盒(新)">
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="紙盒(舊)">
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="梳化套：">
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="床褥套：">
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="110px" label="白水松：">
                        </el-form-item>
                    </el-col>

                </el-row>
                <el-row :gutter="0">
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="新大" prop="big">
                            <el-input placeholder="" v-model="poiItem.big" clearable style="width: 100px;" @change="validatebig(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">個</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="舊大" prop="oldBig">
                            <el-input placeholder="" v-model="poiItem.oldBig" clearable style="width: 100px;" @change="validateoldbig(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">個</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="3座位" prop="threeSeats">
                            <el-input placeholder="" v-model="poiItem.threeSeats" clearable style="width: 100px;" @change="validatethreeSeats(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">張</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="6呎" prop="sixRuler">
                            <el-input placeholder="" v-model="poiItem.sixRuler" clearable style="width: 100px;" @change="validatesixRuler(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">張</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="110px" label="1吋" prop="oneSmall">
                            <el-input placeholder="" v-model="poiItem.oneSmall" clearable style="width: 100px;" @change="validateoneSmall(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">袋</span>
                        </el-form-item>
                    </el-col>

                </el-row>
                <el-row :gutter="0">
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="新中" prop="inthe">
                            <el-input placeholder="" v-model="poiItem.inthe" clearable style="width: 100px;" @change="validateinthe(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">個</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="舊中" prop="oldInthe">
                            <el-input placeholder="" v-model="poiItem.oldInthe" clearable style="width: 100px;" @change="validateoldinthe(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">個</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="2座位" prop="twoSeats">
                            <el-input placeholder="" v-model="poiItem.twoSeats" clearable style="width: 100px;" @change="validatetwoSeats(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">張</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="5呎" prop="fiveRuler">
                            <el-input placeholder="" v-model="poiItem.fiveRuler" clearable style="width: 100px;" @change="validatefiveRuler(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">張</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="110px" label="半吋" prop="small">
                            <el-input placeholder="" v-model="poiItem.small" clearable style="width: 100px;" @change="validatesmall(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">袋</span>
                        </el-form-item>
                    </el-col>

                </el-row>
                <el-row :gutter="0">
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="新細" prop="fine">
                            <el-input placeholder="" v-model="poiItem.fine" clearable style="width: 100px;" @change="validatefine(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">個</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="舊細" prop="oldFine">
                            <el-input placeholder="" v-model="poiItem.oldFine" clearable style="width: 100px;" @change="validateoldfine(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">個</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="1座位" prop="oneSeats">
                            <el-input placeholder="" v-model="poiItem.oneSeats" clearable style="width: 100px;" @change="validateoneSeats(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">張</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="4呎" prop="fourRuler">
                            <el-input placeholder="" v-model="poiItem.fourRuler" clearable style="width: 100px;" @change="validatefourRuler(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">張</span>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="0">
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="">
                            <span style="color: #000000"></span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="">
                            <span style="color: #000000"></span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="">
                            <span style="color: #000000"></span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="3呎" prop="threeRuler">
                            <el-input placeholder="" v-model="poiItem.threeRuler" clearable style="width: 100px;" @change="validatethreeRuler(poiItem)" :disabled="disabledNum">
                            </el-input>
                            <span style="color: #000000">張</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="110px" label=" ">
                            <el-button size="mini" type="danger" v-if="rollingForm.status==0" @click="removeRollItem(poiItem.index)"><i class="fa fa-trash "/></el-button>
                        </el-form-item>
                    </el-col>
                </el-row>

            </div>

            <el-row :gutter="0">
                <el-col :span="23">
                    <el-form-item label-width="100px" label="其他：" prop="oneOther">
                        <el-input placeholder=""   type="textarea"
                                  :autosize="{minRows: 4,maxRows: 4}"
                                  v-model="rollingForm.oneOther" clearable style="width: 900px;">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="0" style="height: 45px">
                <el-col :span="23">
                </el-col>
            </el-row>
            <el-row :gutter="0">
                <el-col :span="23">
                    <el-form-item label-width="100px" label="送盒：">
                        <el-input placeholder=""   type="textarea"
                                  :autosize="{minRows: 4,maxRows: 4}"
                                  clearable style="width: 900px;" v-model="rollingForm.sendBox">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="0" style="height: 45px">
                <el-col :span="23">
                </el-col>
            </el-row>
            <el-row :gutter="0">
                <el-col :span="23">
                    <el-form-item label-width="100px" label="內部備註：">
                        <el-input placeholder=""   type="textarea"
                                  :autosize="{minRows: 4,maxRows: 4}"
                                  clearable style="width: 900px;" v-model="rollingForm.internal">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="0" style="height: 40px">
                <el-col :span="23">
                </el-col>
            </el-row>
            <el-row :gutter="0">
                <el-button type="primary" size="small" style="float: left;margin-bottom: 5px;margin-left: 45px;margin-top:10px;" v-if="rollingForm.status==0"@click="createPoiItem()">添加單</el-button>
                <el-button size="small" type="primary" style="float: left;margin-bottom: 5px;margin-left: 15px;margin-top:10px;" v-if="rollingForm.status==0&&canOut"  v-loading="this.loadingSave" @click="rollSave(1)">確認出倉</el-button>
                <el-button size="small" type="primary" style="float: left;margin-bottom: 5px;margin-left: 15px;margin-top:10px;" v-if="rollingForm.status==0"@click="rollSave(0)"  v-loading="this.loadingSave">保存</el-button>
                <el-button size="small" type="primary" style="float: left;margin-bottom: 5px;margin-left: 15px;margin-top:10px;" v-if="rollingForm.status==1"@click="updateRollSave()">保存</el-button>
                <el-button size="small" type="primary" style="float: left;margin-bottom: 5px;margin-left: 15px;margin-top:10px;" @click="goBack">返回</el-button>
            </el-row>
        </el-form>
    </div>
</template>

<script>
    import axios from 'axios'
    import {getRollingsById,updateRolling,itemRecord,getRollingItemRecordById,getItemAllList,updateRollSave,getRollingListById} from '../api/api'
    export default {
        data() {

            return {
                pickerOptions0: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
                rollingForm:{
                    id:'',
                    feedDate:"",
                    carNumber:'',
                    oneCar:'0.5',
                    twoCar:'1',
                    threeCar:'2',
                    sendBox:'',
                    oneOther:'',
                    internal:''
                },
                rollingRules:{
                    feedDate:[
                        {required: true, message: '日期不能為空', trigger: 'change' },
                    ],
                    carNumber:[
                        {required: true, message: '車號不能為空', trigger: 'change' },
                    ],
                    oneCar:[
                        {required: true, message: '扎車坑紙不能為空', trigger: 'change' },
                    ],
                    twoCar:[
                        {required: true, message: '扎車地膠不能為空', trigger: 'change' },
                    ],
                    threeCar:[
                        {required: true, message: '扎車縐紋紙不能為空', trigger: 'change' },
                    ],
                },
                acctId:'',
                poiItemList:[],
                poiItem:{},
                itemOptions:[],
                disabledNum:false,
                index:0,
                delRollItemList:[],
                loadingSave:false,
                oldoneCar:'',
                oldtwoCar:'',
                oldthreeCar:'',
                feedOldForm:{
                    oldfork:'',
                    oldchelsea:'',
                    oldpitPaper:'',  //坑紙
                    oldnewsPaper:'',  //报纸
                    oldbuBu:'',
                    oldcopyPaper:'',
                    oldmat:'',     //毡
                    oldtinFoil:'', //保鲜纸
                    oldazusa:'',
                    oldshortWood:'',  //矮木
                    oldironCar:'',
                    oldtoGlue:'',
                    oldsoftPaper:'',
                    oldlousyPaper:'',//烂纸
                    oldmoistureproof:'',
                    oldelectric:'',
                    oldgummedPaper:'',
                    oldbig:'',
                    oldinthe:'',
                    oldfine:'',
                    oldoldBig:'',
                    oldoldInthe:'',
                    oldoldFine:'',
                    oldplasma:'',
                    oldcrepePaper:'',
                    oldflatClothing:'',//平衣
                    oldrefrigerator:'',
                    oldelastic:'',//黑色橡筋
                    oldcardboard:'',
                    oldstiff:'',
                    oldbulktank:'',
                    oldpaperCardBoard:'',
                    oldthreeSeats:'',
                    oldtwoSeats:'',
                    oldoneSeats:'',
                    oldthreeRuler:'',
                    oldfourRuler:'',
                    oldfiveRuler:'',
                    oldsixRuler:'',
                    oldoneSmall:'',
                    oldsmall:'',
                    oldtool:'',
                    oldglue:'',
                    oldtoCounter:'',
                    oldcage:'', //铁笼
                    oldtheWire:'',
                    oldplywood:'',
                    oldoneGlue:'',
                    oldwireMesh:'',
                    oldproductCar:'',
                    oldtape:'',
                    oldother:'',
                    oldstatus:'',
                    oldoneCar:'',
                    oldtwoCar:'',
                    oldthreeCar:'',
                    oldsmooth:'',
                    oldlengthFloor:'',
                    oldshortFloor:''
                },

                paramsId:'',
                updateId:0
            }
        },
        methods: {
            removeRollItem(index){
                let i=0;
                let delIndexId=0;
                for(i;i<this.poiItemList.length;i++){
                    console.log("index=="+index)
                    console.log("this.poiItemList[i].index=="+this.poiItemList[i].index)
                    console.log("this.poiItemList[i].id=="+this.poiItemList[i].id)
                    if(index==this.poiItemList[i].index){
                        if(this.poiItemList[i].id!=null){
                            delIndexId = this.poiItemList[i].id;
                            this.delRollItemList.push(delIndexId);
                        }
                        break;
                    }
                }
                this.poiItemList.splice(i,1);
                this.rearrIndex();
            },
            //當發票商品刪除的時候， 重新給每個index 賦值
            rearrIndex(){
                let i = 0;
                for(i=0;i<this.poiItemList.length;i++){
                    this.poiItemList[i].index = i+1;
                }
                this.index = i;
            },
            updateRollSave(){
                if(this.rollingForm.feedDate==''){
                    this.rollingForm.feedDate = 0
                }
                var params = Object.assign({}, this.rollingForm);
                params.delRollItemList=this.delRollItemList;
                delete  params.poiItemsList;
                params.feedDate = Math.round(new Date(params.feedDate).getTime() / 1000);
                updateRollSave(params).then(data => {
                    let {errcode, errmsg} = data.data;
                    if (errcode == 200) {
                        this.$message.success("保存成功");
                        this.resetForm("rollingForm");
                        this.resetForm("poiItem");
                        this.disabledNum=false;
                        this.poiItemList=[];
                        this.acctId='';
                        this.updateId=0;
                        this.$router.push({
                            name:'物料出入倉',
                            params: {str: new Date().getTime()}
                        })
                        this.$store.commit("closeTab",'rollEdit');
                        this.initalRolling();
                    } else {
                        this.$message.error(errmsg);
                    }
                },);
            },
            resetForm(formName){
                if (this.$refs[formName] !== undefined) {
                    this.$refs[formName].resetFields();
                }
            }, msgBox(value) {
                this.$alert(value,this.$t('m.m_info'), {
                    dangerouslyUseHTMLString: true
                });
            },
            validateCarNumber(Number){
                if(Number!='' && Number!=null) {
                    if(Number.length>6){
                        return this.$message.error("車號最多是6個位");
                    }
                }
            },
            validatePitPaperTitle(oneCar){
                if(oneCar!='' && oneCar!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(oneCar)){
                        this.rollingForm.oneCar = "";
                        return this.$message.error("請輸入正確的格式，數字只有2位小數");
                    }else {
                        if (oneCar == 0) {
                            return this.$message.error("輸入的數字要大於0");
                        } else {
                            let num = 0
                            for (var i = 0; i < this.poiItemList.length; i++) {
                                if (this.poiItemList[i].pitPaper == "半") {
                                    num = num + 0.5;
                                } else {
                                    if(this.poiItemList[i].pitPaper!=null && this.poiItemList[i].pitPaper!='') {
                                        num = num + parseFloat(this.poiItemList[i].pitPaper);
                                    }
                                }
                            }
                            let params = {itemName: "坑紙"};
                            itemRecord(params).then(res => {
                                if (res.data.errcode == 200) {
                                    var number = res.data.data;
                                    if(this.rollingForm.id!=null && this.rollingForm.id!='' ) {
                                        let params = {rollId: this.rollingForm.id, field: "PIT_PAPER"};
                                         getRollingItemRecordById(params).then(data => {
                                            let items = data.data.data;
                                            if ((num+parseFloat(oneCar)) > (number + items+parseFloat(this.oldoneCar))) {
                                                this.rollingForm.oneCar = "";
                                                return this.$message.error("坑紙出倉數量大於倉存數！");
                                            }
                                        });
                                    }
                                }
                            });
                        }
                    }
                };
            },
            validateTwoCarTitle(twoCar){
                if(twoCar!='' && twoCar!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(twoCar)){
                        this.rollingForm.twoCar = "";
                        return this.$message.error("請輸入正確的格式，數字只有2位小數");
                    }else {
                        if (twoCar == 0) {
                            return this.$message.error("輸入的數字大於0");
                        } else {
                            let num = 0
                            for (var i = 0; i < this.poiItemList.length; i++) {
                                if (this.poiItemList[i].toGlue == "半") {
                                    num = num + 0.5;
                                } else {
                                    if(this.poiItemList[i].toGlue!=null && this.poiItemList[i].toGlue!='') {
                                        num = num + parseFloat(this.poiItemList[i].toGlue);
                                    }
                                }
                            }
                            let params = {itemName: "地膠"};
                            itemRecord(params).then(res => {
                                if (res.data.errcode == 200) {
                                    var number = res.data.data;
                                    if(this.rollingForm.id!=null && this.rollingForm.id!='' ) {
                                        let params = {rollId: this.rollingForm.id, field: "TOGLUE"};
                                         getRollingItemRecordById(params).then(data => {
                                            let items = data.data.data;
                                            if ((num + parseFloat(twoCar)) > (number + items+parseFloat(this.oldtwoCar))) {
                                                this.rollingForm.twoCar = "";
                                                return this.$message.error("坑紙出倉數量大於倉存數！");
                                            }
                                        });
                                    }
                                }
                            });
                        }
                    }
                };
            },

            validateThreeTitle(threeCar){
                if(threeCar!='' && threeCar!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(threeCar)){
                        this.rollingForm.threeCar = "";
                        return this.$message.error("請輸入正確的格式，數字只有2位小數");
                    }else {
                        if (threeCar == 0) {
                            return this.$message.error("輸入的數字大於0");
                        } else {
                            let num = 0
                            for (var i = 0; i < this.poiItemList.length; i++) {
                                if (this.poiItemList[i].crepePaper == "半") {
                                    num = num + 0.5;
                                } else {
                                    if(this.poiItemList[i].crepePaper!=null && this.poiItemList[i].crepePaper!='') {
                                        num = num + parseFloat(this.poiItemList[i].crepePaper);
                                    }
                                }
                            }
                            let params = {itemName: "縐紋紙"};
                            itemRecord(params).then(res => {
                                if (res.data.errcode == 200) {
                                    var number = res.data.data;
                                    if(this.rollingForm.id!=null && this.rollingForm.id!='' ) {
                                        let params = {rollId: this.rollingForm.id, field: "CREPE_PAPER"};
                                         getRollingItemRecordById(params).then(data => {
                                            let items = data.data.data;
                                            if ((num+parseFloat(threeCar)) > (number + items+parseFloat(this.oldthreeCar))) {
                                                this.rollingForm.threeCar = "";
                                                return this.$message.error("縐紋紙出倉數量大於倉存數！");
                                            }
                                        });
                                    }
                                }
                            });
                        }
                    }
                };
            },
            validatePitPaper(poiItem){
                if(poiItem.pitPaper!='' && poiItem.pitPaper!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.pitPaper)){
                        poiItem.pitPaper = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].pitPaper == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].pitPaper!=null && this.poiItemList[i].pitPaper!='') {
                                    num = num + parseFloat(this.poiItemList[i].pitPaper);
                                }
                            }
                        }
                        if(this.rollingForm.oneCar != "" && this.rollingForm.oneCar != null){
                            num = num + parseFloat(this.rollingForm.oneCar);
                        }
                        let params = {itemName: "坑紙"};
                        return itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ) {
                                    let params = {rollId: this.rollingForm.id, field: "PIT_PAPER"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items+parseFloat(this.oldoneCar))) {
                                            poiItem.pitPaper = "";
                                            return this.$message.error("坑紙出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number+parseFloat(this.oldoneCar)) {
                                        poiItem.pitPaper = "";
                                        return this.$message.error("坑紙出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validatenewsPaper(poiItem){
                if(poiItem.newsPaper!='' && poiItem.newsPaper!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.newsPaper)){
                        poiItem.newsPaper = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].newsPaper == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].newsPaper!=null && this.poiItemList[i].newsPaper!='') {
                                    num = num + parseFloat(this.poiItemList[i].newsPaper);
                                }
                            }
                        }
                        let params = {itemName: "報紙"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "NEWS_PAPER"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.newsPaper = "";
                                            return this.$message.error("坑紙出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.newsPaper = "";
                                        return this.$message.error("坑紙出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validatebuBu(poiItem){
                if(poiItem.buBu!='' && poiItem.buBu!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.buBu)){
                        poiItem.buBu = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].buBu == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].buBu!=null && this.poiItemList[i].buBu!='') {
                                    num = num + parseFloat(this.poiItemList[i].buBu);
                                }
                            }
                        }
                        let params = {itemName: "卜卜膠"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "BUBU"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.buBu = "";
                                            return this.$message.error("卜卜膠出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.buBu = "";
                                        return this.$message.error("卜卜膠出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validatecopyPaper(poiItem){
                if(poiItem.copyPaper!='' && poiItem.copyPaper!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.copyPaper)){
                        poiItem.copyPaper = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].copyPaper == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].copyPaper!=null && this.poiItemList[i].copyPaper!='') {
                                    num = num + parseFloat(this.poiItemList[i].copyPaper);
                                }
                            }
                        }
                        let params = {itemName: "拷貝紙"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "COPY_PAPER"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.copyPaper = "";
                                            return this.$message.error("拷貝紙出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.copyPaper = "";
                                        return this.$message.error("拷貝紙出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validatemat(poiItem){
                if(poiItem.mat!='' && poiItem.mat!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.mat)){
                        poiItem.mat = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].mat == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].mat!=null && this.poiItemList[i].mat!='') {
                                    num = num + parseFloat(this.poiItemList[i].mat);
                                }
                            }
                        }
                        let params = {itemName: "毡"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "MAT"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.mat = "";
                                            return this.$message.error("毡出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.mat = "";
                                        return this.$message.error("毡出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validatetinFoil(poiItem){
                if(poiItem.tinFoil!='' && poiItem.tinFoil!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.tinFoil)){
                        poiItem.tinFoil = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].tinFoil == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].tinFoil!=null && this.poiItemList[i].tinFoil!='') {
                                    num = num + parseFloat(this.poiItemList[i].tinFoil);
                                }
                            }
                        }
                        let params = {itemName: "保鮮紙"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "TIN_FOIL"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.tinFoil = "";
                                            return this.$message.error("保鮮紙出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.tinFoil = "";
                                        return this.$message.error("保鮮紙出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validateazusa(poiItem){
                if(poiItem.azusa!='' && poiItem.azusa!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.azusa)){
                        poiItem.azusa = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].azusa == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].azusa!=null && this.poiItemList[i].azusa!='') {
                                    num = num + parseFloat(this.poiItemList[i].azusa);
                                }
                            }
                        }
                        let params = {itemName: "高木箱"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "AZUSA"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.azusa = "";
                                            return this.$message.error("高木箱出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.azusa = "";
                                        return this.$message.error("高木箱出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validateshortWood(poiItem){
                if(poiItem.shortWood!='' && poiItem.shortWood!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.shortWood)){
                        poiItem.shortWood = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].shortWood == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].shortWood!=null && this.poiItemList[i].shortWood!='') {
                                    num = num + parseFloat(this.poiItemList[i].shortWood);
                                }
                            }
                        }
                        let params = {itemName: "矮木箱"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "SHORT_WOOD"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.shortWood = "";
                                            return this.$message.error("矮木箱出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.shortWood = "";
                                        return this.$message.error("矮木箱出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validateironCar(poiItem){
                if(poiItem.ironCar!='' && poiItem.ironCar!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.ironCar)){
                        poiItem.ironCar = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].ironCar == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].ironCar!=null && this.poiItemList[i].ironCar!='') {
                                    num = num + parseFloat(this.poiItemList[i].ironCar);
                                }
                            }
                        }
                        let params = {itemName: "鐵車"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "IRON_CAR"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.ironCar = "";
                                            return this.$message.error("鐵車出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.ironCar = "";
                                        return this.$message.error("鐵車出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validatetoGlue(poiItem){
                if(poiItem.toGlue!='' && poiItem.toGlue!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.toGlue)){
                        poiItem.toGlue = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].toGlue == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].toGlue!=null && this.poiItemList[i].toGlue!='') {
                                    num = num + parseFloat(this.poiItemList[i].toGlue);
                                }
                            }
                        }
                        if(this.rollingForm.twoCar != "" && this.rollingForm.twoCar != null){
                            num = num + parseFloat(this.rollingForm.twoCar);
                        }
                        let params = {itemName: "地膠"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "TOGLUE"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items+parseFloat(this.oldtwoCar))) {
                                            poiItem.toGlue = "";
                                            return this.$message.error("地膠出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number+parseFloat(this.oldtwoCar)) {
                                        poiItem.toGlue = "";
                                        return this.$message.error("地膠出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validatesoftPaper(poiItem){
                if(poiItem.softPaper!='' && poiItem.softPaper!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.softPaper)){
                        poiItem.softPaper = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].softPaper == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].softPaper!=null && this.poiItemList[i].softPaper!='') {
                                    num = num + parseFloat(this.poiItemList[i].softPaper);
                                }
                            }
                        }
                        let params = {itemName: "軟紙"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "SOFT_PAPER"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.softPaper = "";
                                            return this.$message.error("軟紙出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.softPaper = "";
                                        return this.$message.error("軟紙出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validatelousyPaper(poiItem){
                if(poiItem.lousyPaper!='' && poiItem.lousyPaper!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.lousyPaper)){
                        poiItem.lousyPaper = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].lousyPaper == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].lousyPaper!=null && this.poiItemList[i].lousyPaper!='') {
                                    num = num + parseFloat(this.poiItemList[i].lousyPaper);
                                }
                            }
                        }
                        let params = {itemName: "爛紙"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "LOUSY_PAPER"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.lousyPaper = "";
                                            return this.$message.error("爛紙出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.lousyPaper = "";
                                        return this.$message.error("爛紙出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validatemoistureproof(poiItem){
                if(poiItem.moistureproof!='' && poiItem.moistureproof!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.moistureproof)){
                        poiItem.moistureproof = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].moistureproof == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].moistureproof!=null && this.poiItemList[i].moistureproof!='') {
                                    num = num + parseFloat(this.poiItemList[i].moistureproof);
                                }
                            }
                        }
                        let params = {itemName: "防潮珠"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "MOISTUREPROOF"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.moistureproof = "";
                                            return this.$message.error("防潮珠出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.moistureproof = "";
                                        return this.$message.error("防潮珠出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validateelectric(poiItem){
                if(poiItem.electric!='' && poiItem.electric!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.electric)){
                        poiItem.electric = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].electric == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].electric!=null && this.poiItemList[i].electric!='') {
                                    num = num + parseFloat(this.poiItemList[i].electric);
                                }
                            }
                        }
                        let params = {itemName: "電批"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "ELECTRIC"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.electric = "";
                                            return this.$message.error("電批出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.electric = "";
                                        return this.$message.error("電批出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validategummedPaper(poiItem){
                if(poiItem.gummedPaper!='' && poiItem.gummedPaper!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.gummedPaper)){
                        poiItem.gummedPaper = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].gummedPaper == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].gummedPaper!=null && this.poiItemList[i].gummedPaper!='') {
                                    num = num + parseFloat(this.poiItemList[i].gummedPaper);
                                }
                            }
                        }
                        let params = {itemName: "膠紙"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "GUMMED_PAPER"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.gummedPaper = "";
                                            return this.$message.error("膠紙出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.gummedPaper = "";
                                        return this.$message.error("膠紙出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validatebig(poiItem){
                if(poiItem.big!='' && poiItem.big!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.big)){
                        poiItem.big = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].big == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].big!=null && this.poiItemList[i].big!='') {
                                    num = num + parseFloat(this.poiItemList[i].big);
                                }
                            }
                        }
                        let params = {itemName: "紙盒(新大)"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "BIG"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.big = "";
                                            return this.$message.error("紙盒(新大)出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.big = "";
                                        return this.$message.error("紙盒(新大)出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validateoldbig(poiItem){
                if(poiItem.oldBig!='' && poiItem.oldBig!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.oldBig)){
                        poiItem.oldBig = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].oldBig == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].oldBig!=null && this.poiItemList[i].oldBig!='') {
                                    num = num + parseFloat(this.poiItemList[i].oldBig);
                                }
                            }
                        }
                        let params = {itemName: "紙盒(舊大)"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "OLD_BIG"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.oldBig = "";
                                            return this.$message.error("紙盒(舊大)出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.oldBig = "";
                                        return this.$message.error("紙盒(舊大)出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validateinthe(poiItem){
                if(poiItem.inthe!='' && poiItem.inthe!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.inthe)){
                        poiItem.inthe = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].inthe == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].inthe!=null && this.poiItemList[i].inthe!='') {
                                    num = num + parseFloat(this.poiItemList[i].inthe);
                                }
                            }
                        }
                        let params = {itemName: "紙盒(新中)"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "INTHE"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.inthe = "";
                                            return this.$message.error("紙盒(新中)出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.inthe = "";
                                        return this.$message.error("紙盒(新中)出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validateoldinthe(poiItem){
                if(poiItem.oldInthe!='' && poiItem.oldInthe!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.oldInthe)){
                        poiItem.oldInthe = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].oldInthe == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].oldInthe!=null && this.poiItemList[i].oldInthe!='') {
                                    num = num + parseFloat(this.poiItemList[i].oldInthe);
                                }
                            }
                        }
                        let params = {itemName: "紙盒(舊中)"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "OLD_INTHE"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.oldInthe = "";
                                            return this.$message.error("紙盒(舊中)出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.oldInthe = "";
                                        return this.$message.error("紙盒(舊中)出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validatefine(poiItem){
                if(poiItem.fine!='' && poiItem.fine!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.fine)){
                        poiItem.fine = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].fine == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].fine!=null && this.poiItemList[i].fine!='') {
                                    num = num + parseFloat(this.poiItemList[i].fine);
                                }
                            }
                        }
                        let params = {itemName: "紙盒(新細)"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "FINE"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.fine = "";
                                            return this.$message.error("紙盒(新細)出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.fine = "";
                                        return this.$message.error("紙盒(新細)出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validateoldfine(poiItem){
                if(poiItem.oldFine!='' && poiItem.oldFine!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.oldFine)){
                        poiItem.oldFine = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].oldFine == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].oldFine!=null && this.poiItemList[i].oldFine!='') {
                                    num = num + parseFloat(this.poiItemList[i].oldFine);
                                }
                            }
                        }
                        let params = {itemName: "紙盒(舊細)"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "OLD_FINE"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.oldFine = "";
                                            return this.$message.error("紙盒(舊細)出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.oldFine = "";
                                        return this.$message.error("紙盒(舊細)出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validateplasma(poiItem){
                if(poiItem.plasma!='' && poiItem.plasma!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.plasma)){
                        poiItem.plasma = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].plasma == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].plasma!=null && this.poiItemList[i].plasma!='') {
                                    num = num + parseFloat(this.poiItemList[i].plasma);
                                }
                            }
                        }
                        let params = {itemName: "Plasma"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "PLASMA"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.plasma = "";
                                            return this.$message.error("Plasma出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.plasma = "";
                                        return this.$message.error("Plasma出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validatecrepePaper(poiItem){
                if(poiItem.crepePaper!='' && poiItem.crepePaper!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.crepePaper)){
                        poiItem.crepePaper = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].crepePaper == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].crepePaper!=null && this.poiItemList[i].crepePaper!='') {
                                    num = num + parseFloat(this.poiItemList[i].crepePaper);
                                }
                            }
                        }
                        if(this.rollingForm.threeCar != "" && this.rollingForm.threeCar != null){
                            num = num + parseFloat(this.rollingForm.threeCar);
                        }
                        let params = {itemName: "縐紋紙"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "CREPE_PAPER"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items+parseFloat(this.oldthreeCar))) {
                                            poiItem.crepePaper = "";
                                            return this.$message.error("縐紋紙出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > (number + +parseFloat(this.oldthreeCar))) {
                                        poiItem.crepePaper = "";
                                        return this.$message.error("縐紋紙出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validateflatClothing(poiItem){
                if(poiItem.flatClothing!='' && poiItem.flatClothing!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.flatClothing)){
                        poiItem.flatClothing = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].flatClothing == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].flatClothing!=null && this.poiItemList[i].flatClothing!='') {
                                    num = num + parseFloat(this.poiItemList[i].flatClothing);
                                }
                            }
                        }
                        let params = {itemName: "平衣"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "FLATCLOTHING"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.flatClothing = "";
                                            return this.$message.error("平衣出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.flatClothing = "";
                                        return this.$message.error("平衣出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validaterefrigerator(poiItem){
                if(poiItem.refrigerator!='' && poiItem.refrigerator!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.refrigerator)){
                        poiItem.refrigerator = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].refrigerator == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].refrigerator!=null && this.poiItemList[i].refrigerator!='') {
                                    num = num + parseFloat(this.poiItemList[i].refrigerator);
                                }
                            }
                        }
                        let params = {itemName: "冰箱"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "REFRIGERATOR"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.refrigerator = "";
                                            return this.$message.error("冰箱出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.refrigerator = "";
                                        return this.$message.error("冰箱出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validateelastic(poiItem){
                if(poiItem.elastic!='' && poiItem.elastic!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.elastic)){
                        poiItem.elastic = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].elastic == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].elastic!=null && this.poiItemList[i].elastic!='') {
                                    num = num + parseFloat(this.poiItemList[i].elastic);
                                }
                            }
                        }
                        let params = {itemName: "黑色橡筋"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "ELASTIC"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.elastic = "";
                                            return this.$message.error("黑色橡筋出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.elastic = "";
                                        return this.$message.error("黑色橡筋出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validatecardboard(poiItem){
                if(poiItem.cardboard!='' && poiItem.cardboard!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.cardboard)){
                        poiItem.cardboard = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].cardboard == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].cardboard!=null && this.poiItemList[i].cardboard!='') {
                                    num = num + parseFloat(this.poiItemList[i].cardboard);
                                }
                            }
                        }
                        let params = {itemName: "紙板"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "CARDBOARD"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.cardboard = "";
                                            return this.$message.error("紙板出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.cardboard = "";
                                        return this.$message.error("紙板出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validatestiff(poiItem){
                if(poiItem.stiff!='' && poiItem.stiff!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.stiff)){
                        poiItem.stiff = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].stiff == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].stiff!=null && this.poiItemList[i].stiff!='') {
                                    num = num + parseFloat(this.poiItemList[i].stiff);
                                }
                            }
                        }
                        let params = {itemName: "企身"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "STIFF"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.stiff = "";
                                            return this.$message.error("企身出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.stiff = "";
                                        return this.$message.error("企身出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validatebulktank(poiItem){
                if(poiItem.bulktank!='' && poiItem.bulktank!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.bulktank)){
                        poiItem.bulktank = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].bulktank == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].bulktank!=null && this.poiItemList[i].bulktank!='') {
                                    num = num + parseFloat(this.poiItemList[i].bulktank);
                                }
                            }
                        }
                        let params = {itemName: "散箱"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "BULKTANK"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.bulktank = "";
                                            return this.$message.error("散箱出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.bulktank = "";
                                        return this.$message.error("散箱出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validatepaperCardBoard(poiItem){
                if(poiItem.paperCardBoard!='' && poiItem.paperCardBoard!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.paperCardBoard)){
                        poiItem.paperCardBoard = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].paperCardBoard == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].paperCardBoard!=null && this.poiItemList[i].paperCardBoard!='') {
                                    num = num + parseFloat(this.poiItemList[i].paperCardBoard);
                                }
                            }
                        }
                        let params = {itemName: "紙卡板"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "PAPERCARDBOARD"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.paperCardBoard = "";
                                            return this.$message.error("紙卡板出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.paperCardBoard = "";
                                        return this.$message.error("紙卡板出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validatethreeSeats(poiItem){
                if(poiItem.threeSeats!='' && poiItem.threeSeats!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.threeSeats)){
                        poiItem.threeSeats = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].threeSeats == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].threeSeats!=null && this.poiItemList[i].threeSeats!='') {
                                    num = num + parseFloat(this.poiItemList[i].threeSeats);
                                }
                            }
                        }
                        let params = {itemName: "梳化套(3座位)"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "THREESEATS"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.threeSeats = "";
                                            return this.$message.error("梳化套(3座位)出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.threeSeats = "";
                                        return this.$message.error("梳化套(3座位)出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validatetwoSeats(poiItem){
                if(poiItem.twoSeats!='' && poiItem.twoSeats!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.twoSeats)){
                        poiItem.twoSeats = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].twoSeats == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].twoSeats!=null && this.poiItemList[i].twoSeats!='') {
                                    num = num + parseFloat(this.poiItemList[i].twoSeats);
                                }
                            }
                        }
                        let params = {itemName: "梳化套(2座位)"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "TWOSEATS"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.twoSeats = "";
                                            return this.$message.error("梳化套(2座位)出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.twoSeats = "";
                                        return this.$message.error("梳化套(2座位)出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validateoneSeats(poiItem){
                if(poiItem.oneSeats!='' && poiItem.oneSeats!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.oneSeats)){
                        poiItem.oneSeats = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].oneSeats == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].oneSeats!=null && this.poiItemList[i].oneSeats!='') {
                                    num = num + parseFloat(this.poiItemList[i].oneSeats);
                                }
                            }
                        }
                        let params = {itemName: "梳化套(1座位)"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "ONESEATS"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.oneSeats = "";
                                            return this.$message.error("梳化套(1座位)出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.oneSeats = "";
                                        return this.$message.error("梳化套(1座位)出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validatesixRuler(poiItem){
                if(poiItem.sixRuler!='' && poiItem.sixRuler!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.sixRuler)){
                        poiItem.sixRuler = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].sixRuler == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].sixRuler!=null && this.poiItemList[i].sixRuler!='') {
                                    num = num + parseFloat(this.poiItemList[i].sixRuler);
                                }
                            }
                        }
                        let params = {itemName: "床褥套(6呎)"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "SIXRULER"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.sixRuler = "";
                                            return this.$message.error("床褥套(6呎)出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.sixRuler = "";
                                        return this.$message.error("床褥套(6呎)出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validatefiveRuler(poiItem){
                if(poiItem.fiveRuler!='' && poiItem.fiveRuler!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.fiveRuler)){
                        poiItem.fiveRuler = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].fiveRuler == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].fiveRuler!=null && this.poiItemList[i].fiveRuler!='') {
                                    num = num + parseFloat(this.poiItemList[i].fiveRuler);
                                }
                            }
                        }
                        let params = {itemName: "床褥套(5呎)"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "FIVERULER"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.fiveRuler = "";
                                            return this.$message.error("床褥套(5呎)出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.fiveRuler = "";
                                        return this.$message.error("床褥套(5呎)出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validatefourRuler(poiItem){
                if(poiItem.fourRuler!='' && poiItem.fourRuler!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.fourRuler)){
                        poiItem.fourRuler = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].fourRuler == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].fiveRuler!=null && this.poiItemList[i].fourRuler!='') {
                                    num = num + parseFloat(this.poiItemList[i].fourRuler);
                                }
                            }
                        }
                        let params = {itemName: "床褥套(4呎)"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "FOURRULER"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.fourRuler = "";
                                            return this.$message.error("床褥套(4呎)出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.fourRuler = "";
                                        return this.$message.error("床褥套(4呎)出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validatethreeRuler(poiItem){
                if(poiItem.threeRuler!='' && poiItem.threeRuler!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.threeRuler)){
                        poiItem.threeRuler = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].threeRuler == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].threeRuler!=null && this.poiItemList[i].threeRuler!='') {
                                    num = num + parseFloat(this.poiItemList[i].threeRuler);
                                }
                            }
                        }
                        let params = {itemName: "床褥套(3呎)"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "THREERULER"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.threeRuler = "";
                                            return this.$message.error("床褥套(3呎)出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.threeRuler = "";
                                        return this.$message.error("床褥套(3呎)出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validateoneSmall(poiItem){
                if(poiItem.oneSmall!='' && poiItem.oneSmall!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.oneSmall)){
                        poiItem.oneSmall = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].oneSmall == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].oneSmall!=null && this.poiItemList[i].oneSmall!='') {
                                    num = num + parseFloat(this.poiItemList[i].oneSmall);
                                }
                            }
                        }
                        let params = {itemName: "白水松(1吋)"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "ONESMALL"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.oneSmall = "";
                                            return this.$message.error("白水松(1吋)出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.oneSmall = "";
                                        return this.$message.error("白水松(1吋)出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validatesmall(poiItem){
                if(poiItem.small!='' && poiItem.small!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.small)){
                        poiItem.small = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].small == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].small!=null && this.poiItemList[i].small!='') {
                                    num = num + parseFloat(this.poiItemList[i].small);
                                }
                            }
                        }
                        let params = {itemName: "白水松(半吋)"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "SMALL"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.small = "";
                                            return this.$message.error("白水松(半吋)出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.small = "";
                                        return this.$message.error("白水松(半吋)出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validatetool(poiItem){
                if(poiItem.tool!='' && poiItem.tool!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.tool)){
                        poiItem.tool = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].tool == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].tool!=null && this.poiItemList[i].tool!='') {
                                    num = num + parseFloat(this.poiItemList[i].tool);
                                }
                            }
                        }
                        let params = {itemName: "開木箱工具"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "TOOL"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.tool = "";
                                            return this.$message.error("開木箱工具出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.tool = "";
                                        return this.$message.error("開木箱工具出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validateglue(poiItem){
                if(poiItem.glue!='' && poiItem.glue!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.glue)){
                        poiItem.glue = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].glue == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].glue!=null && this.poiItemList[i].glue!='') {
                                    num = num + parseFloat(this.poiItemList[i].glue);
                                }
                            }
                        }
                        let params = {itemName: "膠(110cm)"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "GLUE"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.glue = "";
                                            return this.$message.error("膠(110cm)出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.glue = "";
                                        return this.$message.error("膠(110cm)出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validatelengthFloor(poiItem){
                if(poiItem.lengthFloor!='' && poiItem.lengthFloor!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.lengthFloor)){
                        poiItem.lengthFloor = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].lengthFloor == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].lengthFloor!=null && this.poiItemList[i].lengthFloor!='') {
                                    num = num + parseFloat(this.poiItemList[i].lengthFloor);
                                }
                            }
                        }
                        let params = {itemName: "地台板(長)"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "LENGTH_FLOOR"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.lengthFloor = "";
                                            return this.$message.error("地台板(長)出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.lengthFloor = "";
                                        return this.$message.error("地台板(長)出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validateshortFloor(poiItem){
                if(poiItem.shortFloor!='' && poiItem.shortFloor!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.shortFloor)){
                        poiItem.shortFloor = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].shortFloor == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].shortFloor!=null && this.poiItemList[i].shortFloor!='') {
                                    num = num + parseFloat(this.poiItemList[i].shortFloor);
                                }
                            }
                        }
                        let params = {itemName: "地台板(短)"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "SHORT_FLOOR"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.lengthFloor = "";
                                            return this.$message.error("地台板(短)出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.lengthFloor = "";
                                        return this.$message.error("地台板(短)出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validatecage(poiItem){
                if(poiItem.cage!='' && poiItem.cage!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.cage)){
                        poiItem.cage = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].cage == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].cage!=null && this.poiItemList[i].cage!='') {
                                    num = num + parseFloat(this.poiItemList[i].cage);
                                }
                            }
                        }
                        let params = {itemName: "铁笼"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "CAGE"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.cage = "";
                                            return this.$message.error("铁笼出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.cage = "";
                                        return this.$message.error("铁笼出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validateplywood(poiItem){
                if(poiItem.plywood!='' && poiItem.plywood!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.plywood)){
                        poiItem.plywood = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].plywood == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].plywood!=null && this.poiItemList[i].plywood!='') {
                                    num = num + parseFloat(this.poiItemList[i].plywood);
                                }
                            }
                        }
                        let params = {itemName: "夾板(長)"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "PLYWOOD"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.plywood = "";
                                            return this.$message.error("夾板(長)出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.plywood = "";
                                        return this.$message.error("夾板(長)出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validatetheWire(poiItem){
                if(poiItem.theWire!='' && poiItem.theWire!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.theWire)){
                        poiItem.theWire = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].theWire == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].theWire!=null && this.poiItemList[i].theWire!='') {
                                    num = num + parseFloat(this.poiItemList[i].theWire);
                                }
                            }
                        }
                        let params = {itemName: "吊繩"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "THEWIRE"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.theWire = "";
                                            return this.$message.error("吊繩出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.theWire = "";
                                        return this.$message.error("吊繩出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validateoneGlue(poiItem){
                if(poiItem.oneGlue!='' && poiItem.oneGlue!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.oneGlue)){
                        poiItem.oneGlue = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].oneGlue == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].oneGlue!=null && this.poiItemList[i].oneGlue!='') {
                                    num = num + parseFloat(this.poiItemList[i].oneGlue);
                                }
                            }
                        }
                        let params = {itemName: "膠(120cm)"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "ONEGLUE"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.oneGlue = "";
                                            return this.$message.error("膠(120cm)出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.oneGlue = "";
                                        return this.$message.error("膠(120cm)出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validatewireMesh(poiItem){
                if(poiItem.wireMesh!='' && poiItem.wireMesh!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.wireMesh)){
                        poiItem.wireMesh = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].wireMesh == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].wireMesh!=null && this.poiItemList[i].wireMesh!='') {
                                    num = num + parseFloat(this.poiItemList[i].wireMesh);
                                }
                            }
                        }
                        let params = {itemName: "搬花網"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "WIREMESH"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.wireMesh = "";
                                            return this.$message.error("搬花網出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.wireMesh = "";
                                        return this.$message.error("搬花網出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validateproductCar(poiItem){
                if(poiItem.productCar!='' && poiItem.productCar!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.productCar)){
                        poiItem.productCar = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].productCar == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].productCar!=null && this.poiItemList[i].productCar!='') {
                                    num = num + parseFloat(this.poiItemList[i].productCar);
                                }
                            }
                        }
                        let params = {itemName: "積車"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "PRODUCTCAR"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.productCar = "";
                                            return this.$message.error("積車出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.productCar = "";
                                        return this.$message.error("積車出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validatetape(poiItem){
                if(poiItem.tape!='' && poiItem.tape!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.tape)){
                        poiItem.tape = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].tape == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].tape!=null && this.poiItemList[i].tape!='') {
                                    num = num + parseFloat(this.poiItemList[i].tape);
                                }
                            }
                        }
                        let params = {itemName: "膠紙冚"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "TAPE"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.tape = "";
                                            return this.$message.error("膠紙冚出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.tape = "";
                                        return this.$message.error("膠紙冚出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validatefork(poiItem){
                if(poiItem.fork!='' && poiItem.fork!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.fork)){
                        poiItem.fork = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].fork == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].fork!=null && this.poiItemList[i].fork!='') {
                                    num = num + parseFloat(this.poiItemList[i].fork);
                                }
                            }
                        }
                        let params = {itemName: "叉"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "FORK"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.fork = "";
                                            return this.$message.error("叉出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.fork = "";
                                        return this.$message.error("叉出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validatechelsea(poiItem){
                if(poiItem.chelsea!='' && poiItem.chelsea!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.chelsea)){
                        poiItem.chelsea = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].chelsea == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].chelsea!=null && this.poiItemList[i].chelsea!='') {
                                    num = num + parseFloat(this.poiItemList[i].chelsea);
                                }
                            }
                        }
                        let params = {itemName: "車仔"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "CHELSEA"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.chelsea = "";
                                            return this.$message.error("車仔出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.chelsea = "";
                                        return this.$message.error("車仔出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },
            validatesmooth(poiItem){
                if(poiItem.smooth!='' && poiItem.smooth!=null){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(poiItem.smooth)){
                        poiItem.smooth = "";
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }else {
                        let num = 0
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].smooth == "半") {
                                num = num + 0.5;
                            } else {
                                if(this.poiItemList[i].smooth!=null && this.poiItemList[i].smooth!='') {
                                    num = num + parseFloat(this.poiItemList[i].smooth);
                                }
                            }
                        }
                        let params = {itemName: "滑潤"};
                        itemRecord(params).then(res => {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if(poiItem.id!=null && poiItem.id!='' ){
                                    let params = {rollId:this.rollingForm.id,field: "SMOOTH"};
                                    return getRollingItemRecordById(params).then(data => {
                                        let items = data.data.data;
                                        if (num > (number + items)) {
                                            poiItem.smooth = "";
                                            return this.$message.error("滑潤出倉數量大於倉存數！");
                                        }
                                    });
                                }else{
                                    if (num > number) {
                                        poiItem.smooth = "";
                                        return this.$message.error("滑潤出倉數量大於倉存數！");
                                    }
                                }
                            }
                        });
                    }
                };
            },

            rollSave(ev){
                if(ev==1){
                    this.$confirm(this.$t('m.m_outconfirm'), this.$t('m.m_info'), {
                        confirmButtonText: this.$t('m.t_confirm'),
                        cancelButtonText: this.$t('m.b_cancel'),
                        type: 'warning'
                    }).then(() => {
                        this.rollIngsSave(ev);
                    });
                }else{
                    this.rollIngsSave(ev);
                }
            },
            rollIngsSave(ev){
                if(this.poiItemList.length==0){
                    return this.$message.error("請新增單信息！");
                }
                this.$refs.rollingForm.validate((valid) => {
                        if (valid) {
                if(this.rollingForm.carNumber!='' && this.rollingForm.carNumber!=null) {
                    if(this.rollingForm.carNumber.length>6){
                        return this.$message.error("車號最多是6個位");
                    }
                }
                this.loadingSave=true;
                if(this.rollingForm.feedDate==''){
                    this.rollingForm.feedDate = 0
                }
                if(this.poiItemList.length!=0){
                    this.rollingForm.poiItemsList = this.poiItemsJson();
                }
                var params = Object.assign({}, this.rollingForm);
                params.feedDate = Math.round(new Date(params.feedDate).getTime() / 1000);
                params.delRollItemList=this.delRollItemList;
                params.status=ev;
                updateRolling(params).then(data => {
                    let {errcode, errmsg} = data.data;
                    if (errcode == 200) {
                        if(ev==1){
                            this.$message.success("出倉成功");
                        }else {
                            this.$message.success("保存成功");
                        }
                        this.loadingSave=false;
                        this.resetForm("rollingForm");
                        this.resetForm("poiItem");
                        this.disabledNum=false;
                        this.poiItemList=[];
                        this.acctId='';
                        this.updateId=0;
                        this.$router.push({
                            name:'物料出入倉',
                            params: {str: new Date().getTime()}
                        })
                        this.$store.commit("closeTab",'rollEdit');
                        this.initalRolling();
                    } else {
                        this.$message.error(errmsg);
                        this.loadingSave=false;
                    }
                },);}
                });
            },
            goBack(){
                this.updateId=0;
                this.$router.push({
                    name:'物料出入倉',
                    params:{str:new Date().getTime()}
                })
                this.$store.commit("closeTab","rollEdit");
                this.initalRolling();
            },


            createPoiItem(){
                this.poiItem={index:this.index+=1, pitPaper:'',  //坑紙
                    newsPaper:'',  //报纸
                    buBu:'',
                    copyPaper:'',
                    mat:'',     //毡
                    tinFoil:'', //保鲜纸
                    azusa:'',
                    shortWood:'',  //矮木
                    ironCar:'',
                    toGlue:'',
                    softPaper:'',
                    lousyPaper:'',
                    moistureproof:'',
                    electric:'',
                    gummedPaper:'',
                    big:'',
                    inthe:'',
                    fine:'',
                    oldBig:'',
                    oldInthe:'',
                    oldFine:'',
                    plasma:'',
                    crepePaper:'',
                    flatClothing:'',
                    refrigerator:'',
                    elastic:'',
                    cardboard:'',
                    stiff:'',
                    bulktank:'',
                    paperCardBoard:'',
                    threeSeats:'',
                    twoSeats:'',
                    oneSeats:'',
                    threeRuler:'',
                    fourRuler:'',
                    fiveRuler:'',
                    sixRuler:'',
                    oneSmall:'',
                    small:'',
                    tool:'',
                    glue:'',
                    lengthFloor:'',
                    cage:'',
                    theWire:'',
                    plywood:'',
                    oneGlue:'',
                    wireMesh:'',
                    productCar:'',
                    tape:'',
                    other:''
                };

                /*for (var i = 0; i < this.itemOptions.length; i++) {
                    if(this.itemOptions[i].itemName=="坑紙"){
                        let number = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                          /!*  if (this.poiItemList[j].id != null && this.poiItemList[j].id != '') {
                                let params = {rollId: this.rollingForm.id, field: "NEWS_PAPER"};
                                getRollingItemRecordById(params).then(data => {
                                    let items = data.data.data;
                                    oldnumber = oldnumber + items;
                                });
                            }*!/
                            if (this.poiItemList[j].pitPaper != '' && this.poiItemList[j].pitPaper != null) {
                                number = number + parseFloat(this.poiItemList[j].pitPaper);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+parseFloat(this.oldoneCar)+this.feedOldForm.oldoneCar;
                        if(numValue!=0){
                            if(this.rollingForm.oneCar !='' && this.rollingForm.oneCar !=null){
                                if (numValue-parseFloat(this.rollingForm.oneCar) > 0) {
                                    this.poiItem.pitPaper=numValue-parseFloat(this.rollingForm.oneCar);
                                }else{
                                    this.poiItem.pitPaper="";
                                }
                            }else {
                                this.poiItem.pitPaper=numValue;
                            }
                        }else{
                            this.poiItem.pitPaper='';
                        }
                    }else if(this.itemOptions[i].itemName=="報紙"){
                        let number = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].newsPaper!='' && this.poiItemList[j].newsPaper!=null) {
                                number = number + parseFloat(this.poiItemList[j].newsPaper);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldnewsPaper;
                        if(numValue!=0){
                            this.poiItem.newsPaper=numValue;
                        }else{
                            this.poiItem.newsPaper='';
                        }
                        // this.poiItem.newsPaper=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number;
                    }else if(this.itemOptions[i].itemName=="卜卜膠"){
                        let number = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].buBu!='' && this.poiItemList[j].buBu!=null) {
                                number = number + parseFloat(this.poiItemList[j].buBu);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldbuBu;
                        if(numValue!=0){
                            this.poiItem.buBu=numValue;
                        }else{
                            this.poiItem.buBu='';
                        }
                    }else if(this.itemOptions[i].itemName=="拷貝紙"){
                        let number = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].copyPaper!='' && this.poiItemList[j].copyPaper!=null) {
                                number = number + parseFloat(this.poiItemList[j].copyPaper);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldcopyPaper;
                        if(numValue!=0){
                            this.poiItem.copyPaper=numValue;
                        }else{
                            this.poiItem.copyPaper='';
                        }
                    }else if(this.itemOptions[i].itemName=="毡"){
                        let number = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].mat!='' && this.poiItemList[j].mat!=null) {
                                number = number + parseFloat(this.poiItemList[j].mat);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldmat;
                        if(numValue!=0){
                            this.poiItem.mat=numValue;
                        }else{
                            this.poiItem.mat='';
                        }
                    }else if(this.itemOptions[i].itemName=="保鮮紙"){
                        let number = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].tinFoil!='' && this.poiItemList[j].tinFoil!=null) {
                                number = number + parseFloat(this.poiItemList[j].tinFoil);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldtinFoil;
                        if(numValue!=0){
                            this.poiItem.tinFoil=numValue;
                        }else{
                            this.poiItem.tinFoil='';
                        }
                    }else if(this.itemOptions[i].itemName=="高木箱"){
                        let number = 0
                        let oldnumber = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].azusa!='' && this.poiItemList[j].azusa!=null) {
                                number = number + parseFloat(this.poiItemList[j].azusa);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldazusa;
                        if(numValue!=0){
                            this.poiItem.azusa=numValue;
                        }else{
                            this.poiItem.azusa='';
                        }
                    }else if(this.itemOptions[i].itemName=="矮木箱"){
                        let number = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].shortWood!='' && this.poiItemList[j].shortWood!=null) {
                                number = number + parseFloat(this.poiItemList[j].shortWood);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldshortWood;
                        if(numValue!=0){
                            this.poiItem.shortWood=numValue;
                        }else{
                            this.poiItem.shortWood='';
                        }
                    }else if(this.itemOptions[i].itemName=="鐵車"){
                        let number = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].ironCar!='' && this.poiItemList[j].ironCar!=null) {
                                number = number + parseFloat(this.poiItemList[j].ironCar);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldironCar;
                        if(numValue!=0){
                            this.poiItem.ironCar=numValue;
                        }else{
                            this.poiItem.ironCar='';
                        }
                    }else if(this.itemOptions[i].itemName=="車仔"){
                        let number = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].chelsea!='' && this.poiItemList[j].chelsea!=null) {
                                number = number + parseFloat(this.poiItemList[j].chelsea);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldchelsea;
                        if(numValue!=0){
                            this.poiItem.chelsea=numValue;
                        }else{
                            this.poiItem.chelsea='';
                        }
                    }else if(this.itemOptions[i].itemName=="軟紙"){
                        let number = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].softPaper!='' && this.poiItemList[j].softPaper!=null) {
                                number = number + parseFloat(this.poiItemList[j].softPaper);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldsoftPaper;
                        if(numValue!=0){
                            this.poiItem.softPaper=numValue;
                        }else{
                            this.poiItem.softPaper='';
                        }
                    }else if(this.itemOptions[i].itemName=="爛紙"){
                        let number = 0
                         let oldnumber = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].lousyPaper!='' && this.poiItemList[j].lousyPaper!=null) {
                                number = number + parseFloat(this.poiItemList[j].lousyPaper);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldlousyPaper;
                        if(numValue!=0){
                            this.poiItem.lousyPaper=numValue;
                        }else{
                            this.poiItem.lousyPaper='';
                        }
                    }else if(this.itemOptions[i].itemName=="防潮珠"){
                        let number = 0
                         let oldnumber = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].moistureproof!='' && this.poiItemList[j].moistureproof!=null) {
                                number = number + parseFloat(this.poiItemList[j].moistureproof);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldmoistureproof;
                        if(numValue!=0){
                            this.poiItem.moistureproof=numValue;
                        }else{
                            this.poiItem.moistureproof='';
                        }
                    }else if(this.itemOptions[i].itemName=="電批"){
                        let number = 0
                         let oldnumber = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].electric!='' && this.poiItemList[j].electric!=null) {
                                number = number + parseFloat(this.poiItemList[j].electric);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldelectric;
                        if(numValue!=0){
                            this.poiItem.electric=numValue;
                        }else{
                            this.poiItem.electric='';
                        }
                    }else if(this.itemOptions[i].itemName=="叉"){
                        let number = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].fork!='' && this.poiItemList[j].fork!=null) {
                                number = number + parseFloat(this.poiItemList[j].fork);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldfork;
                        if(numValue!=0){
                            this.poiItem.fork=numValue;
                        }else{
                            this.poiItem.fork='';
                        }
                    }else if(this.itemOptions[i].itemName=="地膠"){
                        let number = 0
                         let oldnumber = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].toGlue!='' && this.poiItemList[j].toGlue!=null) {
                                number = number + parseFloat(this.poiItemList[j].toGlue);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+parseFloat(this.oldtwoCar)+this.feedOldForm.oldtoGlue;
                        if(numValue!=0){
                            if(this.rollingForm.twoCar !='' && this.rollingForm.twoCar !=null){
                                if ( numValue-parseFloat(this.rollingForm.twoCar) > 0) {
                                    this.poiItem.toGlue=numValue-parseFloat(this.rollingForm.twoCar);
                                }else{
                                    this.poiItem.toGlue="";
                                }
                            }else {
                                this.poiItem.toGlue=numValue;
                            }
                        }else{
                            this.poiItem.toGlue='';
                        }
                    }else if(this.itemOptions[i].itemName=="膠紙"){
                        let number = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].gummedPaper!='' && this.poiItemList[j].gummedPaper!=null) {
                                number = number + parseFloat(this.poiItemList[j].gummedPaper);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldgummedPaper;
                        if(numValue!=0){
                            this.poiItem.gummedPaper=numValue;
                        }else{
                            this.poiItem.gummedPaper='';
                        }
                    }else if(this.itemOptions[i].itemName=="铁笼"){
                        let number = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].cage!='' && this.poiItemList[j].cage!=null) {
                                number = number + parseFloat(this.poiItemList[j].cage);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldcage;
                        if(numValue!=0){
                            this.poiItem.cage=numValue;
                        }else{
                            this.poiItem.cage='';
                        }
                    }else if(this.itemOptions[i].itemName=="夾板(長)"){
                        let number = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].plywood!='' && this.poiItemList[j].plywood!=null) {
                                number = number + parseFloat(this.poiItemList[j].plywood);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldplywood;
                        if(numValue!=0){
                            this.poiItem.plywood=numValue;
                        }else{
                            this.poiItem.plywood='';
                        }
                    }else if(this.itemOptions[i].itemName=="新大"){
                        let number = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].big!='' && this.poiItemList[j].big!=null) {
                                number = number + parseFloat(this.poiItemList[j].big);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldbig;
                        if(numValue!=0){
                            this.poiItem.big=numValue;
                        }else{
                            this.poiItem.big='';
                        }
                    }else if(this.itemOptions[i].itemName=="新中"){
                        let number = 0
                         let oldnumber = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].inthe!='' && this.poiItemList[j].inthe!=null) {
                                number = number + parseFloat(this.poiItemList[j].inthe);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldinthe;
                        if(numValue!=0){
                            this.poiItem.inthe=numValue;
                        }else{
                            this.poiItem.inthe='';
                        }
                    }else if(this.itemOptions[i].itemName=="新細"){
                        let number = 0
                         let oldnumber = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].fine!='' && this.poiItemList[j].fine!=null) {
                                number = number + parseFloat(this.poiItemList[j].fine);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldfine;
                        if(numValue!=0){
                            this.poiItem.fine=numValue;
                        }else{
                            this.poiItem.fine='';
                        }
                    }else if(this.itemOptions[i].itemName=="舊大"){
                        let number = 0
                         let oldnumber = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].oldBig!='' && this.poiItemList[j].oldBig!=null) {
                                number = number + parseFloat(this.poiItemList[j].oldBig);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldoldBig;
                        if(numValue!=0){
                            this.poiItem.oldBig=numValue;
                        }else{
                            this.poiItem.oldBig='';
                        }
                    }else if(this.itemOptions[i].itemName=="舊中"){
                        let number = 0
                         let oldnumber = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].oldInthe!='' && this.poiItemList[j].oldInthe!=null) {
                                number = number + parseFloat(this.poiItemList[j].oldInthe);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldoldInthe;
                        if(numValue!=0){
                            this.poiItem.oldInthe=numValue;
                        }else{
                            this.poiItem.oldInthe='';
                        }
                    }else if(this.itemOptions[i].itemName=="舊細"){
                        let number = 0
                         let oldnumber = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].oldFine!='' && this.poiItemList[j].oldFine!=null) {
                                number = number + parseFloat(this.poiItemList[j].oldFine);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldoldFine;
                        if(numValue!=0){
                            this.poiItem.oldFine=numValue;
                        }else{
                            this.poiItem.oldFine='';
                        }
                    }else if(this.itemOptions[i].itemName=="Plasma"){
                        let number = 0
                         let oldnumber = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].plasma!='' && this.poiItemList[j].plasma!=null) {
                                number = number + parseFloat(this.poiItemList[j].plasma);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldplasma;
                        if(numValue!=0){
                            this.poiItem.plasma=numValue;
                        }else{
                            this.poiItem.plasma='';
                        }
                    }else if(this.itemOptions[i].itemName=="縐紋紙"){
                        let number = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].crepePaper!='' && this.poiItemList[j].crepePaper!=null) {
                                number = number + parseFloat(this.poiItemList[j].crepePaper);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+parseFloat(this.oldthreeCar)+this.feedOldForm.oldcrepePaper;
                        if(numValue!=0){
                            if(this.rollingForm.threeCar !='' && this.rollingForm.threeCar !=null){
                                if ( numValue-parseFloat(this.rollingForm.threeCar) > 0) {
                                    this.poiItem.crepePaper=numValue-parseFloat(this.rollingForm.threeCar);
                                }else{
                                    this.poiItem.crepePaper="";
                                }
                            }else {
                                this.poiItem.crepePaper=numValue;
                            }
                        }else{
                            this.poiItem.crepePaper='';
                        }
                    }else if(this.itemOptions[i].itemName=="冰箱"){
                        let number = 0
                         let oldnumber = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].refrigerator!='' && this.poiItemList[j].refrigerator!=null) {
                                number = number + parseFloat(this.poiItemList[j].refrigerator);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldrefrigerator;
                        if(numValue!=0){
                            this.poiItem.refrigerator=numValue;
                        }else{
                            this.poiItem.refrigerator='';
                        }
                    }else if(this.itemOptions[i].itemName=="黑色橡筋"){
                        let number = 0
                         let oldnumber = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].elastic!='' && this.poiItemList[j].elastic!=null) {
                                number = number + parseFloat(this.poiItemList[j].elastic);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldelastic;
                        if(numValue!=0){
                            this.poiItem.elastic=numValue;
                        }else{
                            this.poiItem.elastic='';
                        }
                    }else if(this.itemOptions[i].itemName=="紙板"){
                        let number = 0
                         let oldnumber = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].cardboard!='' && this.poiItemList[j].cardboard!=null) {
                                number = number + parseFloat(this.poiItemList[j].cardboard);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldcardboard;
                        if(numValue!=0){
                            this.poiItem.cardboard=numValue;
                        }else{
                            this.poiItem.cardboard='';
                        }
                    }else if(this.itemOptions[i].itemName=="企身"){
                        let number = 0
                         let oldnumber = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].stiff!='' && this.poiItemList[j].stiff!=null) {
                                number = number + parseFloat(this.poiItemList[j].stiff);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldstiff;
                        if(numValue!=0){
                            this.poiItem.stiff=numValue;
                        }else{
                            this.poiItem.stiff='';
                        }
                    }else if(this.itemOptions[i].itemName=="散箱"){
                        let number = 0
                         let oldnumber = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].bulktank!='' && this.poiItemList[j].bulktank!=null) {
                                number = number + parseFloat(this.poiItemList[j].bulktank);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldbulktank;
                        if(numValue!=0){
                            this.poiItem.bulktank=numValue;
                        }else{
                            this.poiItem.bulktank='';
                        }
                    }else if(this.itemOptions[i].itemName=="紙卡板"){
                        let number = 0
                         let oldnumber = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].paperCardBoard!='' && this.poiItemList[j].paperCardBoard!=null) {
                                number = number + parseFloat(this.poiItemList[j].paperCardBoard);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldpaperCardBoard;
                        if(numValue!=0){
                            this.poiItem.paperCardBoard=numValue;
                        }else{
                            this.poiItem.paperCardBoard='';
                        }
                    }else if(this.itemOptions[i].itemName=="3座位"){
                        let number = 0
                         let oldnumber = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].threeSeats!='' && this.poiItemList[j].threeSeats!=null) {
                                number = number + parseFloat(this.poiItemList[j].threeSeats);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldthreeSeats;
                        if(numValue!=0){
                            this.poiItem.threeSeats=numValue;
                        }else{
                            this.poiItem.threeSeats='';
                        }
                    }else if(this.itemOptions[i].itemName=="2座位"){
                        let number = 0
                         let oldnumber = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].twoSeats!='' && this.poiItemList[j].twoSeats!=null) {
                                number = number + parseFloat(this.poiItemList[j].twoSeats);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldtwoSeats;
                        if(numValue!=0){
                            this.poiItem.twoSeats=numValue;
                        }else{
                            this.poiItem.twoSeats='';
                        }
                    }else if(this.itemOptions[i].itemName=="1座位"){
                        let number = 0
                         let oldnumber = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].oneSeats!='' && this.poiItemList[j].oneSeats!=null) {
                                number = number + parseFloat(this.poiItemList[j].oneSeats);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldoneSeats;
                        if(numValue!=0){
                            this.poiItem.oneSeats=numValue;
                        }else{
                            this.poiItem.oneSeats='';
                        }
                    }else if(this.itemOptions[i].itemName=="6呎"){
                        let number = 0
                         let oldnumber = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].sixRuler!='' && this.poiItemList[j].sixRuler!=null) {
                                number = number + parseFloat(this.poiItemList[j].sixRuler);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldsixRuler;
                        if(numValue!=0){
                            this.poiItem.sixRuler=numValue;
                        }else{
                            this.poiItem.sixRuler='';
                        }
                    }else if(this.itemOptions[i].itemName=="5呎"){
                        let number = 0
                         let oldnumber = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].fiveRuler!='' && this.poiItemList[j].fiveRuler!=null) {
                                number = number + parseFloat(this.poiItemList[j].fiveRuler);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldfiveRuler;
                        if(numValue!=0){
                            this.poiItem.fiveRuler=numValue;
                        }else{
                            this.poiItem.fiveRuler='';
                        }
                    }else if(this.itemOptions[i].itemName=="4呎"){
                        let number = 0
                         let oldnumber = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItem.index!=this.poiItemList[j].index && this.poiItemList[j].id==''&& this.poiItemList[j].id==null){
                                if(this.poiItemList[j].fourRuler!='' && this.poiItemList[j].fourRuler!=null) {
                                    number = number + parseFloat(this.poiItemList[j].fourRuler);
                                }
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldfourRuler;
                        if(numValue!=0){
                            this.poiItem.fourRuler=numValue;
                        }else{
                            this.poiItem.fourRuler='';
                        }
                    }else if(this.itemOptions[i].itemName=="3呎"){
                        let number = 0
                         let oldnumber = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].threeRuler!='' && this.poiItemList[j].threeRuler!=null) {
                                number = number + parseFloat(this.poiItemList[j].threeRuler);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldthreeRuler;
                        if(numValue!=0){
                            this.poiItem.threeRuler=numValue;
                        }else{
                            this.poiItem.threeRuler='';
                        }
                    }else if(this.itemOptions[i].itemName=="1吋"){
                        let number = 0
                         let oldnumber = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].oneSmall!='' && this.poiItemList[j].oneSmall!=null) {
                                number = number + parseFloat(this.poiItemList[j].oneSmall);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldoneSmall;
                        if(numValue!=0){
                            this.poiItem.oneSmall=numValue;
                        }else{
                            this.poiItem.oneSmall='';
                        }
                    }else if(this.itemOptions[i].itemName=="半吋"){
                        let number = 0
                         let oldnumber = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].small!='' && this.poiItemList[j].small!=null) {
                                number = number + parseFloat(this.poiItemList[j].small);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldsmall;
                        if(numValue!=0){
                            this.poiItem.small=numValue;
                        }else{
                            this.poiItem.small='';
                        }
                    }else if(this.itemOptions[i].itemName=="吊繩"){
                        let number = 0
                         let oldnumber = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].theWire!='' && this.poiItemList[j].theWire!=null) {
                                number = number + parseFloat(this.poiItemList[j].theWire);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldtheWire;
                        if(numValue!=0){
                            this.poiItem.theWire=numValue;
                        }else{
                            this.poiItem.theWire='';
                        }
                        //this.poiItem.theWire=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number;
                    }else if(this.itemOptions[i].itemName=="搬花網"){
                        let number = 0
                         let oldnumber = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].wireMesh!='' && this.poiItemList[j].wireMesh!=null) {
                                number = number + parseFloat(this.poiItemList[j].wireMesh);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldwireMesh;
                        if(numValue!=0){
                            this.poiItem.wireMesh=numValue;
                        }else{
                            this.poiItem.wireMesh='';
                        }
                    }else if(this.itemOptions[i].itemName=="開木箱工具"){
                        let number = 0
                         let oldnumber = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].tool!='' && this.poiItemList[j].tool!=null) {
                                number = number + parseFloat(this.poiItemList[j].tool);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldtool;
                        if(numValue!=0){
                            this.poiItem.tool=numValue;
                        }else{
                            this.poiItem.tool='';
                        }
                    }else if(this.itemOptions[i].itemName=="地台板(長)"){
                        let number = 0
                         let oldnumber = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].lengthFloor!='' && this.poiItemList[j].lengthFloor!=null) {
                                number = number + parseFloat(this.poiItemList[j].lengthFloor);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldlengthFloor;
                        if(numValue!=0){
                            this.poiItem.lengthFloor=numValue;
                        }else{
                            this.poiItem.lengthFloor='';
                        }
                    }else if(this.itemOptions[i].itemName=="滑潤"){
                        let number = 0
                         let oldnumber = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].smooth!='' && this.poiItemList[j].smooth!=null) {
                                number = number + parseFloat(this.poiItemList[j].smooth);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldsmooth;
                        if(numValue!=0){
                            this.poiItem.smooth=numValue;
                        }else{
                            this.poiItem.smooth='';
                        }
                    }else if(this.itemOptions[i].itemName=="積車"){
                        let number = 0
                         let oldnumber = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].productCar!='' && this.poiItemList[j].productCar!=null) {
                                number = number + parseFloat(this.poiItemList[j].productCar);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldproductCar;
                        if(numValue!=0){
                            this.poiItem.productCar=numValue;
                        }else{
                            this.poiItem.productCar='';
                        }
                    }else if(this.itemOptions[i].itemName=="膠(110cm)"){
                        let number = 0
                         let oldnumber = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].glue!='' && this.poiItemList[j].glue!=null) {
                                number = number + parseFloat(this.poiItemList[j].glue);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldglue;
                        if(numValue!=0){
                            this.poiItem.glue=numValue;
                        }else{
                            this.poiItem.glue='';
                        }
                    }else if(this.itemOptions[i].itemName=="地台板(短)"){
                        let number = 0
                         let oldnumber = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].shortFloor!='' && this.poiItemList[j].shortFloor!=null) {
                                number = number + parseFloat(this.poiItemList[j].shortFloor);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldshortFloor;
                        if(numValue!=0){
                            this.poiItem.shortFloor=numValue;
                        }else{
                            this.poiItem.shortFloor='';
                        }
                        //this.poiItem.shortFloor=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number;
                    }else if(this.itemOptions[i].itemName=="膠(120cm)"){
                        let number = 0
                         let oldnumber = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].oneGlue!='' && this.poiItemList[j].oneGlue!=null) {
                                number = number + parseFloat(this.poiItemList[j].oneGlue);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldoneGlue;
                        if(numValue!=0){
                            this.poiItem.oneGlue=numValue;
                        }else{
                            this.poiItem.oneGlue='';
                        }
                    }else if(this.itemOptions[i].itemName=="膠紙冚"){
                        let number = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if (this.poiItemList[j].tape != '' && this.poiItemList[j].tape != null) {
                                number = number + parseFloat(this.poiItemList[j].tape);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldtape;
                        if(numValue!=0){
                            this.poiItem.tape=numValue;
                        }else{
                            this.poiItem.tape='';
                        }
                    }else if(this.itemOptions[i].itemName=="平衣"){
                        let number = 0
                        for (var j = 0; j < this.poiItemList.length; j++) {
                            if(this.poiItemList[j].flatClothing!='' && this.poiItemList[j].flatClothing!=null) {
                                number = number + parseFloat(this.poiItemList[j].flatClothing);
                            }
                        }
                        let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldflatClothing;
                        if(numValue!=0){
                            this.poiItem.flatClothing=numValue;
                        }else{
                            this.poiItem.flatClothing='';
                        }
                    }
                }*/
                this.poiItemList.push(this.poiItem);
                //}
            },
            // 提交時, 把所有報價單商品轉換成json Str
            poiItemsJson(){
                var jsonStr='[';
                for(var i =0;i<this.poiItemList.length;i++){
                    jsonStr += '{';
                    if(this.poiItemList[i].id!=null){
                        jsonStr += "\"id\":\"" + this.poiItemList[i].id+"\",";
                    }
                    if(this.poiItemList[i].pitPaper!=null&& this.poiItemList[i].pitPaper!=''&& this.poiItemList[i].pitPaper!=undefined) {
                        jsonStr += "\"pitPaper\":\"" + this.poiItemList[i].pitPaper + "\",";
                    }
                    if(this.poiItemList[i].newsPaper!=null&& this.poiItemList[i].newsPaper!=''&& this.poiItemList[i].newsPaper!=undefined) {
                        jsonStr += "\"newsPaper\":\"" + this.poiItemList[i].newsPaper + "\",";
                    }
                    if(this.poiItemList[i].buBu!=null&& this.poiItemList[i].buBu!=''&& this.poiItemList[i].buBu!=undefined) {
                        jsonStr += "\"buBu\":\"" + this.poiItemList[i].buBu + "\",";
                    }
                    if(this.poiItemList[i].copyPaper!=null&& this.poiItemList[i].copyPaper!=''&& this.poiItemList[i].copyPaper!=undefined) {
                        jsonStr += "\"copyPaper\":\"" + this.poiItemList[i].copyPaper + "\",";
                    }
                    if(this.poiItemList[i].mat!=null&& this.poiItemList[i].mat!=''&& this.poiItemList[i].mat!=undefined) {
                        jsonStr += "\"mat\":\"" + this.poiItemList[i].mat + "\",";
                    }
                    if(this.poiItemList[i].tinFoil!=null&& this.poiItemList[i].tinFoil!=''&& this.poiItemList[i].tinFoil!=undefined) {
                        jsonStr += "\"tinFoil\":\"" + this.poiItemList[i].tinFoil + "\",";
                    }
                    if(this.poiItemList[i].azusa!=null&& this.poiItemList[i].azusa!=''&& this.poiItemList[i].azusa!=undefined) {
                        jsonStr += "\"azusa\":\"" + this.poiItemList[i].azusa + "\",";
                    }
                    if(this.poiItemList[i].shortWood!=null&& this.poiItemList[i].shortWood!=''&& this.poiItemList[i].shortWood!=undefined) {
                        jsonStr += "\"shortWood\":\"" + this.poiItemList[i].shortWood + "\",";
                    }
                    if(this.poiItemList[i].ironCar!=null && this.poiItemList[i].ironCar!=''&& this.poiItemList[i].ironCar!=undefined){
                        jsonStr += "\"ironCar\":\"" + this.poiItemList[i].ironCar+"\",";
                    }
                    if(this.poiItemList[i].toGlue!=null&& this.poiItemList[i].toGlue!=''&& this.poiItemList[i].toGlue!=undefined) {
                        jsonStr += "\"toGlue\":\"" + this.poiItemList[i].toGlue + "\",";
                    }
                    if(this.poiItemList[i].softPaper!=null&& this.poiItemList[i].softPaper!=''&& this.poiItemList[i].softPaper!=undefined) {
                        jsonStr += "\"softPaper\":\"" + this.poiItemList[i].softPaper + "\",";
                    }
                    if(this.poiItemList[i].lousyPaper!=null&& this.poiItemList[i].lousyPaper!=''&& this.poiItemList[i].lousyPaper!=undefined) {
                        jsonStr += "\"lousyPaper\":\"" + this.poiItemList[i].lousyPaper + "\",";
                    }
                    if(this.poiItemList[i].moistureproof!=null&& this.poiItemList[i].moistureproof!=''&& this.poiItemList[i].moistureproof!=undefined) {
                        jsonStr += "\"moistureproof\":\"" + this.poiItemList[i].moistureproof + "\",";
                    }
                    if(this.poiItemList[i].electric!=null&& this.poiItemList[i].electric!=''&& this.poiItemList[i].electric!=undefined) {
                        jsonStr += "\"electric\":\"" + this.poiItemList[i].electric + "\",";
                    }
                    if(this.poiItemList[i].gummedPaper!=null&& this.poiItemList[i].gummedPaper!=''&& this.poiItemList[i].gummedPaper!=undefined) {
                        jsonStr += "\"gummedPaper\":\"" + this.poiItemList[i].gummedPaper + "\",";
                    }
                    if(this.poiItemList[i].big!=null&& this.poiItemList[i].big!=''&& this.poiItemList[i].big!=undefined) {
                        jsonStr += "\"big\":\"" + this.poiItemList[i].big + "\",";
                    }
                    if(this.poiItemList[i].inthe!=null&& this.poiItemList[i].inthe!=''&& this.poiItemList[i].inthe!=undefined) {
                        jsonStr += "\"inthe\":\"" + this.poiItemList[i].inthe + "\",";
                    }
                    if(this.poiItemList[i].fine!=null&& this.poiItemList[i].fine!=''&& this.poiItemList[i].fine!=undefined) {
                        jsonStr += "\"fine\":\"" + this.poiItemList[i].fine + "\",";
                    }
                    if(this.poiItemList[i].oldBig!=null&& this.poiItemList[i].oldBig!=''&& this.poiItemList[i].oldBig!=undefined) {
                        jsonStr += "\"oldBig\":\"" + this.poiItemList[i].oldBig + "\",";
                    }
                    if(this.poiItemList[i].oldInthe!=null&& this.poiItemList[i].oldInthe!=''&& this.poiItemList[i].oldInthe!=undefined) {
                        jsonStr += "\"oldInthe\":\"" + this.poiItemList[i].oldInthe + "\",";
                    }
                    if(this.poiItemList[i].oldFine!=null&& this.poiItemList[i].oldFine!=''&& this.poiItemList[i].oldFine!=undefined) {
                        jsonStr += "\"oldFine\":\"" + this.poiItemList[i].oldFine + "\",";
                    }
                    if(this.poiItemList[i].plasma!=null&& this.poiItemList[i].plasma!=''&& this.poiItemList[i].plasma!=undefined) {
                        jsonStr += "\"plasma\":\"" + this.poiItemList[i].plasma + "\",";
                    }
                    if(this.poiItemList[i].crepePaper!=null&& this.poiItemList[i].crepePaper!=''&& this.poiItemList[i].crepePaper!=undefined) {
                        jsonStr += "\"crepePaper\":\"" + this.poiItemList[i].crepePaper + "\",";
                    }
                    if(this.poiItemList[i].flatClothing!=null&& this.poiItemList[i].flatClothing!=''&& this.poiItemList[i].flatClothing!=undefined) {
                        jsonStr += "\"flatClothing\":\"" + this.poiItemList[i].flatClothing + "\",";
                    }
                    if(this.poiItemList[i].refrigerator!=null&& this.poiItemList[i].refrigerator!=''&& this.poiItemList[i].refrigerator!=undefined) {
                        jsonStr += "\"refrigerator\":\"" + this.poiItemList[i].refrigerator + "\",";
                    }
                    if(this.poiItemList[i].elastic!=null&& this.poiItemList[i].elastic!=''&& this.poiItemList[i].elastic!=undefined) {
                        jsonStr += "\"elastic\":\"" + this.poiItemList[i].elastic + "\",";
                    }
                    if(this.poiItemList[i].cardboard!=null&& this.poiItemList[i].cardboard!=''&& this.poiItemList[i].cardboard!=undefined) {
                        jsonStr += "\"cardboard\":\"" + this.poiItemList[i].cardboard + "\",";
                    }
                    if(this.poiItemList[i].stiff!=null&& this.poiItemList[i].stiff!=''&& this.poiItemList[i].stiff!=undefined) {
                        jsonStr += "\"stiff\":\"" + this.poiItemList[i].stiff + "\",";
                    }
                    if(this.poiItemList[i].bulktank!=null&& this.poiItemList[i].bulktank!=''&& this.poiItemList[i].bulktank!=undefined) {
                        jsonStr += "\"bulktank\":\"" + this.poiItemList[i].bulktank + "\",";
                    }
                    if(this.poiItemList[i].paperCardBoard!=null&& this.poiItemList[i].paperCardBoard!=''&& this.poiItemList[i].paperCardBoard!=undefined) {
                        jsonStr += "\"paperCardBoard\":\"" + this.poiItemList[i].paperCardBoard + "\",";
                    }
                    if(this.poiItemList[i].threeSeats!=null&& this.poiItemList[i].threeSeats!=''&& this.poiItemList[i].threeSeats!=undefined) {
                        jsonStr += "\"threeSeats\":\"" + this.poiItemList[i].threeSeats + "\",";
                    }
                    if(this.poiItemList[i].twoSeats!=null&& this.poiItemList[i].twoSeats!=''&& this.poiItemList[i].twoSeats!=undefined) {
                        jsonStr += "\"twoSeats\":\"" + this.poiItemList[i].twoSeats + "\",";
                    }
                    if(this.poiItemList[i].oneSeats!=null&& this.poiItemList[i].oneSeats!=''&& this.poiItemList[i].oneSeats!=undefined) {
                        jsonStr += "\"oneSeats\":\"" + this.poiItemList[i].oneSeats + "\",";
                    }
                    if(this.poiItemList[i].sixRuler!=null&& this.poiItemList[i].sixRuler!=''&& this.poiItemList[i].sixRuler!=undefined) {
                        jsonStr += "\"sixRuler\":\"" + this.poiItemList[i].sixRuler + "\",";
                    }
                    if(this.poiItemList[i].fiveRuler!=null&& this.poiItemList[i].fiveRuler!=''&& this.poiItemList[i].fiveRuler!=undefined) {
                        jsonStr += "\"fiveRuler\":\"" + this.poiItemList[i].fiveRuler + "\",";
                    }
                    if(this.poiItemList[i].fourRuler!=null&& this.poiItemList[i].fourRuler!=''&& this.poiItemList[i].fourRuler!=undefined) {
                        jsonStr += "\"fourRuler\":\"" + this.poiItemList[i].fourRuler + "\",";
                    }
                    if(this.poiItemList[i].threeRuler!=null&& this.poiItemList[i].threeRuler!=''&& this.poiItemList[i].threeRuler!=undefined) {
                        jsonStr += "\"threeRuler\":\"" + this.poiItemList[i].threeRuler + "\",";
                    }
                    if(this.poiItemList[i].oneSmall!=null&& this.poiItemList[i].oneSmall!=''&& this.poiItemList[i].oneSmall!=undefined) {
                        jsonStr += "\"oneSmall\":\"" + this.poiItemList[i].oneSmall + "\",";
                    }
                    if(this.poiItemList[i].small!=null&& this.poiItemList[i].small!=''&& this.poiItemList[i].small!=undefined) {
                        jsonStr += "\"small\":\"" + this.poiItemList[i].small + "\",";
                    }
                    if(this.poiItemList[i].tool!=null&& this.poiItemList[i].tool!=''&& this.poiItemList[i].tool!=undefined) {
                        jsonStr += "\"tool\":\"" + this.poiItemList[i].tool + "\",";
                    }
                    if(this.poiItemList[i].glue!=null&& this.poiItemList[i].glue!=''&& this.poiItemList[i].glue!=undefined) {
                        jsonStr += "\"glue\":\"" + this.poiItemList[i].glue + "\",";
                    }
                    if(this.poiItemList[i].cage!=null&& this.poiItemList[i].cage!=''&& this.poiItemList[i].cage!=undefined) {
                        jsonStr += "\"cage\":\"" + this.poiItemList[i].cage + "\",";
                    }
                    if(this.poiItemList[i].theWire!=null&& this.poiItemList[i].theWire!=''&& this.poiItemList[i].theWire!=undefined) {
                        jsonStr += "\"theWire\":\"" + this.poiItemList[i].theWire + "\",";
                    }
                    if(this.poiItemList[i].plywood!=null&& this.poiItemList[i].plywood!=''&& this.poiItemList[i].plywood!=undefined) {
                        jsonStr += "\"plywood\":\"" + this.poiItemList[i].plywood + "\",";
                    }
                    if(this.poiItemList[i].oneGlue!=null&& this.poiItemList[i].oneGlue!=''&& this.poiItemList[i].oneGlue!=undefined) {
                        jsonStr += "\"oneGlue\":\"" + this.poiItemList[i].oneGlue + "\",";
                    }
                    if(this.poiItemList[i].wireMesh!=null&& this.poiItemList[i].wireMesh!=''&& this.poiItemList[i].wireMesh!=undefined) {
                        jsonStr += "\"wireMesh\":\"" + this.poiItemList[i].wireMesh + "\",";
                    }
                    if(this.poiItemList[i].productCar!=null&& this.poiItemList[i].productCar!=''&& this.poiItemList[i].productCar!=undefined) {
                        jsonStr += "\"productCar\":\"" + this.poiItemList[i].productCar + "\",";
                    }
                    if(this.poiItemList[i].tape!=null&& this.poiItemList[i].tape!=''&& this.poiItemList[i].tape!=undefined) {
                        jsonStr += "\"tape\":\"" + this.poiItemList[i].tape + "\",";
                    }
                    if(this.poiItemList[i].other!=null&& this.poiItemList[i].other!=''&& this.poiItemList[i].other!=undefined) {
                        jsonStr += "\"other\":\"" + this.poiItemList[i].other + "\",";
                    }
                    if(this.poiItemList[i].fork!=null&& this.poiItemList[i].fork!=''&& this.poiItemList[i].fork!=undefined) {
                        jsonStr += "\"fork\":\"" + this.poiItemList[i].fork + "\",";
                    }
                    if(this.poiItemList[i].shortFloor!=null&&this.poiItemList[i].shortFloor!=''&& this.poiItemList[i].shortFloor!=undefined) {
                        jsonStr += "\"shortFloor\":\"" + this.poiItemList[i].shortFloor + "\",";
                    }
                    if(this.poiItemList[i].chelsea!=null&&this.poiItemList[i].chelsea!=''&& this.poiItemList[i].chelsea!=undefined) {
                        jsonStr += "\"chelsea\":\"" + this.poiItemList[i].chelsea + "\",";
                    }
                    if(this.poiItemList[i].smooth!=null&&this.poiItemList[i].smooth!=''&& this.poiItemList[i].smooth!=undefined) {
                        jsonStr += "\"smooth\":\"" + this.poiItemList[i].smooth + "\",";
                    }
                    if(this.poiItemList[i].lengthFloor!=null&&this.poiItemList[i].lengthFloor!=''&& this.poiItemList[i].lengthFloor!=undefined) {
                        jsonStr += "\"lengthFloor\":\"" + this.poiItemList[i].lengthFloor + "\"";
                    }else{
                        jsonStr += "\"lengthFloor\":\"" + "" + "\"";
                    }
                    jsonStr += '}'
                    jsonStr += ','
                }
                jsonStr = jsonStr.substring(0, jsonStr.length -1);
                jsonStr += ']';
                if(jsonStr.length==1){
                    return null;
                }
                return jsonStr;
            },
            getItemOption(){
                getItemAllList().then(data => {
                    this.itemOptions = data.data.data;
                });
            },
            getFeedParams(){
                this.acctId='';
                this.initalRolling();
                if (this.acctId == '') {
                    this.acctId = this.$route.params.outId;
                    if (this.acctId != '' || this.acctId != undefined) {
                        this.queryOneAcctRec(this.acctId);
                        this.queryOneRollList(this.acctId);
                        this.paramsId=this.acctId;
                    }
                }
                if (this.acctId != this.$route.params.outId && this.$route.params.outId != undefined) {
                    this.acctId = this.$route.params.outId;
                    this.paramsId=this.acctId;
                    this.queryOneAcctRec(this.acctId);
                    this.queryOneRollList(this.acctId);
                }
            },
            initalRolling(){
                this.poiItem={index:'', pitPaper:'',  //坑紙
                    newsPaper:'',  //报纸
                    buBu:'', copyPaper:'',
                    mat:'',     //毡
                    tinFoil:'', //保鲜纸
                    azusa:'',
                    shortWood:'',  //矮木
                    ironCar:'',
                    toGlue:'', softPaper:'', lousyPaper:'', moistureproof:'', electric:'',
                    gummedPaper:'', big:'', inthe:'', fine:'',oldBig:'', oldInthe:'', oldFine:'', plasma:'', crepePaper:'', flatClothing:'',
                    refrigerator:'', elastic:'', cardboard:'', stiff:'', bulktank:'', paperCardBoard:'',
                    threeSeats:'', twoSeats:'', oneSeats:'', threeRuler:'', fourRuler:'', fiveRuler:'',
                    cage:'', theWire:'', plywood:'', oneGlue:'', wireMesh:'', productCar:'', tape:'',other:'',
                    fork:'',  //叉
                    shortFloor:'', //短木板
                    lengthFloor:'',
                    chelsea:'',//車仔
                    smooth:'',   //滑潤
                };
                this.rollingForm={
                    id:'',
                    feedDate:"",
                    carNumber:'',
                    oneCar:'',
                    twoCar:'',
                    threeCar:'',
                    sendBox:'',
                    oneOther:'',
                    internal:''
                };
                this.poiItemList=[];
                this.acctId="";
                this.disabledNum=false;
                this.delRollItemList=[];
                this.index=0;
                this.loadingSave=false;
                this.oldoneCar=0;
                this.oldtwoCar=0;
                this.oldthreeCar=0;
            },
            validateChange(ev){
                if(ev!=null && ev!=''){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(ev!="半" && !re.test(ev)){
                        this.$message.error("請輸入正確的格式，數字只有2位小數");
                        return false;
                    }
                }
            },
            queryOneAcctRec(acctId){
                if(acctId!=undefined){
                    return getRollingsById(acctId).then(data => {
                        let item = data.data;
                        if (item != null) {
                            Object.assign(this.rollingForm, item.data);
                            if(item.data.status==1){
                                this.disabledNum=true;
                            }
                            if (item.data.feedDate == null || item.data.feedDate == '' ||item.data.feedDate == 0) {
                                this.rollingForm.feedDate = "";
                            } else {
                                this.rollingForm.feedDate = new Date(item.data.feedDate * 1000);
                            }
                            if (item.data.oneCar != null && item.data.oneCar != '') {
                                this.oldoneCar = item.data.oneCar;
                            }
                            if (item.data.oldtwoCar != null && item.data.oldtwoCar != '') {
                                this.oldtwoCar = item.data.oldtwoCar;
                            }
                            if (item.data.oldthreeCar != null && item.data.oldthreeCar != '') {
                                this.oldthreeCar = item.data.oldthreeCar;
                            }
                            if(item.data.rollingItem!=null){
                                let tempList = item.data.rollingItem;
                                for(let i=0;i<tempList.length;i++){
                                    let poiItem=tempList[i];
                                    poiItem.index = this.index+=1;
                                    poiItem.pitPaper = poiItem.pitPaper;
                                    poiItem.newsPaper = poiItem.newsPaper;
                                    poiItem.buBu = poiItem.buBu;
                                    poiItem.copyPaper = poiItem.copyPaper;
                                    this.poiItemList.push(poiItem);
                                }
                            }
                        }
                    });
                }
            },
            queryOneRollList(acctId){
                if(acctId!=undefined) {
                    return getRollingListById(acctId).then(data => {
                        let item = data.data;
                        if (item != null) {
                            if (item.data.rollingItem != null) {
                                let tempList = item.data.rollingItem;
                                for (let i = 0; i < tempList.length; i++) {
                                    let poiItem = tempList[i];
                                    Object.assign({}, this.feedOldForm);
                                    this.feedOldForm.oldpitPaper=poiItem.pitPaper;  //坑紙
                                    this.feedOldForm.oldnewsPaper=poiItem.newsPaper;  //报纸
                                    this.feedOldForm.oldbuBu=poiItem.buBu;
                                    this.feedOldForm.oldcopyPaper=poiItem.copyPaper;
                                    this.feedOldForm.oldmat=poiItem.mat;     //毡
                                    this.feedOldForm.oldtinFoil=poiItem.tinFoil; //保鲜纸
                                    this.feedOldForm.oldazusa=poiItem.azusa==0;
                                    this.feedOldForm.oldshortWood=poiItem.shortWood;  //矮木
                                    this.feedOldForm.oldironCar=poiItem.ironCar;
                                    this.feedOldForm.oldtoGlue=poiItem.toGlue;
                                    this.feedOldForm.oldsoftPaper=poiItem.softPaper;
                                    this.feedOldForm.oldlousyPaper=poiItem.lousyPaper;//烂纸
                                    this.feedOldForm.oldmoistureproof=poiItem.moistureproof;
                                    this.feedOldForm.oldelectric=poiItem.electric;
                                    this.feedOldForm.oldgummedPaper=poiItem.gummedPaper;
                                    this.feedOldForm.oldbig=poiItem.big;
                                    this.feedOldForm.oldinthe=poiItem.inthe;
                                    this.feedOldForm.oldfine=poiItem.fine;
                                    this.feedOldForm.oldoldBig=poiItem.oldBig==0;
                                    this.feedOldForm.oldoldInthe=poiItem.oldInthe==0;
                                    this.feedOldForm.oldoldFine=poiItem.oldFine;
                                    this.feedOldForm.oldplasma=poiItem.plasma;
                                    this.feedOldForm.oldcrepePaper=poiItem.crepePaper;
                                    this.feedOldForm.oldflatClothing=poiItem.flatClothing;//平衣
                                    this.feedOldForm.oldrefrigerator=poiItem.refrigerator;
                                    this.feedOldForm.oldelastic=poiItem.elastic;//黑色橡筋
                                    this.feedOldForm.oldcardboard=poiItem.cardboard;
                                    this.feedOldForm.oldstiff=poiItem.stiff;
                                    this.feedOldForm.oldbulktank=poiItem.bulktank;
                                    this.feedOldForm.oldpaperCardBoard=poiItem.paperCardBoard;
                                    this.feedOldForm.oldthreeSeats=poiItem.threeSeats;
                                    this.feedOldForm.oldtwoSeats=poiItem.twoSeats;
                                    this.feedOldForm.oldoneSeats=poiItem.oneSeats;
                                    this.feedOldForm.oldthreeRuler=poiItem.threeRuler;
                                    this.feedOldForm.oldfourRuler=poiItem.fourRuler;
                                    this.feedOldForm.oldfiveRuler=poiItem.fiveRuler;
                                    this.feedOldForm.oldsixRuler=poiItem.sixRuler;
                                    this.feedOldForm.oldoneSmall=poiItem.oneSmall;
                                    this.feedOldForm.oldsmall=poiItem.small;
                                    this.feedOldForm.oldtool=poiItem.tool;
                                    this.feedOldForm.oldglue=poiItem.glue;
                                    this.feedOldForm.oldtoCounter=poiItem.toCounter;
                                    this.feedOldForm.oldcage=poiItem.cage; //铁笼
                                    this.feedOldForm.oldtheWire=poiItem.theWire;
                                    this.feedOldForm.oldplywood=poiItem.plywood;
                                    this.feedOldForm.oldoneGlue=poiItem.oneGlue;
                                    this.feedOldForm.oldwireMesh=poiItem.wireMesh;
                                    this.feedOldForm.oldproductCar=poiItem.productCar;
                                    this.feedOldForm.oldtape=poiItem.tape;
                                    this.feedOldForm.oldother=poiItem.other;
                                    this.feedOldForm.oldstatus=poiItem.status;
                                    this.feedOldForm.oldsmooth=poiItem.smooth;
                                    this.feedOldForm.oldlengthFloor=poiItem.lengthFloor;
                                    this.feedOldForm.oldshortFloor=poiItem.shortFloor;
                                    this.feedOldForm.oldfork=poiItem.fork;
                                    this.feedOldForm.oldchelsea=poiItem.chelsea;
                                }
                            }
                        }
                    });
                }
            },
        },
        mounted() {
            ///console.log("=====mounted")
            //this.getFeedParams();
        },
       /* watch: {
        // 利用watch方法检测路由变化：
        '$route': function (to, from) {
            //console.log(to.params.outId+"===tototototto==="+this.paramsId+"==="+this.paramsName)
            if(to.params.outId!= this.paramsId && to.name=='編輯出倉紙'){
                this.getFeedParams();
            }
        }
        },*/
        activated(){
           this.getItemOption();
            let outId = this.$route.params.outId;
            console.log(outId+"==="+this.paramsId+"=="+this.updateId);
            if (outId!= '' && outId!= null &&  outId!= undefined) {
                if(outId!= this.paramsId && this.updateId==0){
                    this.getFeedParams();
                }else if(outId== this.paramsId && this.updateId==0){
                    this.getFeedParams();
                }
            }
            this.updateId=1;
        },
        computed: {
            canOut(){
                return this.$store.getters.hasPermission("ROLL_OUT");
            }
        }
    }

</script>

<style lang="scss">
    .el-col-4{
        height: 35px;
    }
    .el-col-23{
        height: 35px;
    }
    .el-col-16{
        height: 35px;
    }
    .menu {
        .right {
            float: right;
        }
    }

    .el-tag + .el-tag {
        margin-left: 5px;
    }
    .dataListTable .cell {
        white-space: nowrap;
    }
</style>



// WEBPACK FOOTER //
// src/views/UpdateRolling.vue